export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  VerticalFieldValueScalar: any;
};

export type AcceptanceRate = {
  __typename?: "AcceptanceRate";
  belowMinimum?: Maybe<Scalars["Boolean"]>;
  jobs: Scalars["Int"];
  needsHigherFee?: Maybe<Scalars["Boolean"]>;
  percent: Scalars["Int"];
  tipFee?: Maybe<Scalars["Int"]>;
};

export type ActivityLog = {
  __typename?: "ActivityLog";
  message: Scalars["String"];
  timestamp: Scalars["ISO8601DateTime"];
  username: Scalars["String"];
};

/** The connection type for ActivityLog. */
export type ActivityLogConnection = {
  __typename?: "ActivityLogConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityLogEdge>>>;
  /** A list of nodes. */
  nodes: Array<ActivityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type ActivityLogEdge = {
  __typename?: "ActivityLogEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: ActivityLog;
};

export type Address = {
  __typename?: "Address";
  addressLine1: Scalars["String"];
  addressLine2?: Maybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  county?: Maybe<Scalars["String"]>;
  postcode: Scalars["String"];
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  county?: InputMaybe<Scalars["String"]>;
  postcode?: InputMaybe<Scalars["String"]>;
};

export type Agency = {
  __typename?: "Agency";
  active: Scalars["Boolean"];
  agencyReviews?: Maybe<ReviewConnection>;
  agentInvitations?: Maybe<Array<AgentInvitation>>;
  agents?: Maybe<UserConnection>;
  allTalent?: Maybe<Array<User>>;
  archived: Scalars["Boolean"];
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  bio?: Maybe<Scalars["String"]>;
  commissionPercentage?: Maybe<Scalars["Int"]>;
  commissionRateHistory?: Maybe<AgencyCommissionHistoryConnection>;
  coverPhoto?: Maybe<Asset>;
  firstParty?: Maybe<Scalars["Boolean"]>;
  hideTalent?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  instagramUsername?: Maybe<Scalars["String"]>;
  isPrivate?: Maybe<Scalars["Boolean"]>;
  jobs?: Maybe<JobsConnection>;
  lastCommisionRateHistoryUpdate?: Maybe<Scalars["String"]>;
  location: Scalars["String"];
  logo?: Maybe<Asset>;
  name: Scalars["String"];
  packages?: Maybe<PackageConnection>;
  pastClients?: Maybe<Array<Scalars["String"]>>;
  paymentsEmail?: Maybe<Scalars["String"]>;
  representation: Scalars["String"];
  slug: Scalars["String"];
  specialities?: Maybe<Array<Scalars["String"]>>;
  talent?: Maybe<User>;
  talentInvitations?: Maybe<Array<TalentInvitation>>;
  tiktokUsername?: Maybe<Scalars["String"]>;
  twitterUsername?: Maybe<Scalars["String"]>;
};

export type AgencyAgencyReviewsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  agencyId?: InputMaybe<Scalars["ID"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type AgencyAgentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  agentName?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  roles?: InputMaybe<Array<AgentProfileRole>>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type AgencyCommissionRateHistoryArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type AgencyJobsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<JobFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type AgencyPackagesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  agencyName?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  creatorName?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<PackageState>;
};

export type AgencyTalentArgs = {
  id?: InputMaybe<Scalars["ID"]>;
};

export type AgencyBreakdown = {
  __typename?: "AgencyBreakdown";
  agencyCommissionFee?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  bookingCommissionFee?: Maybe<Scalars["String"]>;
  recipientName?: Maybe<Scalars["String"]>;
  recipientType?: Maybe<Scalars["String"]>;
};

export type AgencyBrief = {
  __typename?: "AgencyBrief";
  broadLocation?: Maybe<Scalars["String"]>;
  contactMessage: Scalars["String"];
  deliverables: Array<Scalars["String"]>;
  displayBrand: Scalars["String"];
  sourceFingerprint?: Maybe<Scalars["String"]>;
  state: Scalars["String"];
  summary: Scalars["String"];
  title: Scalars["String"];
  travelTerms?: Maybe<Scalars["String"]>;
  usage?: Maybe<Scalars["String"]>;
  warnings: Array<Scalars["String"]>;
  workingWindow?: Maybe<Scalars["String"]>;
};

export type AgencyBriefInput = {
  broadLocation: Scalars["String"];
  deliverables?: InputMaybe<Array<Scalars["String"]>>;
  displayBrand: Scalars["String"];
  summary: Scalars["String"];
  title: Scalars["String"];
  travelTerms: Scalars["String"];
  usage?: InputMaybe<Scalars["String"]>;
  workingWindow: Scalars["String"];
};

export type AgencyCommissionHistory = {
  __typename?: "AgencyCommissionHistory";
  percentage?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["ISO8601DateTime"]>;
};

/** The connection type for AgencyCommissionHistory. */
export type AgencyCommissionHistoryConnection = {
  __typename?: "AgencyCommissionHistoryConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AgencyCommissionHistoryEdge>>>;
  /** A list of nodes. */
  nodes: Array<AgencyCommissionHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type AgencyCommissionHistoryEdge = {
  __typename?: "AgencyCommissionHistoryEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: AgencyCommissionHistory;
};

/** The connection type for Agency. */
export type AgencyConnection = {
  __typename?: "AgencyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AgencyEdge>>>;
  /** A list of nodes. */
  nodes: Array<Agency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type AgencyEdge = {
  __typename?: "AgencyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Agency;
};

export type AgencyFilterInput = {
  lifecycle?: InputMaybe<Scalars["String"]>;
  locations?: InputMaybe<Array<Scalars["String"]>>;
  name?: InputMaybe<Scalars["String"]>;
};

export enum AgencyJobState {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Confirmed = "CONFIRMED",
  Expired = "EXPIRED",
  Paid = "PAID",
  PendingBookerResponse = "PENDING_BOOKER_RESPONSE",
  PendingTalentResponse = "PENDING_TALENT_RESPONSE",
  RejectedByBooker = "REJECTED_BY_BOOKER",
  RejectedByTalent = "REJECTED_BY_TALENT",
}

export type AgencyLifecycleBlocker = {
  __typename?: "AgencyLifecycleBlocker";
  code: Scalars["String"];
  count: Scalars["Int"];
  ids: Array<Scalars["ID"]>;
  message: Scalars["String"];
};

export type AgencyLifecycleJob = {
  __typename?: "AgencyLifecycleJob";
  invoiceIds: Array<Scalars["ID"]>;
  jobId: Scalars["ID"];
  path: Scalars["String"];
  paymentIds: Array<Scalars["ID"]>;
};

export type AgencyLifecyclePerson = {
  __typename?: "AgencyLifecyclePerson";
  name: Scalars["String"];
  talentProfileId: Scalars["ID"];
  userId: Scalars["ID"];
  vertical: Scalars["String"];
};

export type AgencyLifecyclePreview = {
  __typename?: "AgencyLifecyclePreview";
  active: Scalars["Boolean"];
  agencyId: Scalars["ID"];
  archived: Scalars["Boolean"];
  blockers: Array<AgencyLifecycleBlocker>;
  canArchive: Scalars["Boolean"];
  canRestore: Scalars["Boolean"];
  hideTalent?: Maybe<Scalars["Boolean"]>;
  historicalJobs: Array<AgencyLifecycleJob>;
  invitationCount: Scalars["Int"];
  isPrivate?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  pendingAgentInvitationIds: Array<Scalars["ID"]>;
  pendingTalentInvitationIds: Array<Scalars["ID"]>;
  roster: Array<AgencyLifecyclePerson>;
  rosterCount: Scalars["Int"];
  rosterProfileIds: Array<Scalars["ID"]>;
};

export type AgencyRosterTransfer = {
  __typename?: "AgencyRosterTransfer";
  actorId?: Maybe<Scalars["ID"]>;
  actorName?: Maybe<Scalars["String"]>;
  adminActorId?: Maybe<Scalars["ID"]>;
  adminActorName?: Maybe<Scalars["String"]>;
  agreementEvidence: Scalars["JSON"];
  destinationAgencyId: Scalars["ID"];
  id: Scalars["ID"];
  inputDigest: Scalars["String"];
  performedAt: Scalars["ISO8601DateTime"];
  previewVersion: Scalars["String"];
  requestKey: Scalars["String"];
  sourceAgencyId: Scalars["ID"];
  talentProfileIds: Array<Scalars["ID"]>;
  userIds: Array<Scalars["ID"]>;
};

export type AgencyTransferAgreementInput = {
  evidenceReference: Scalars["String"];
  talentProfileId: Scalars["ID"];
};

export type AgencyTransferBlocker = {
  __typename?: "AgencyTransferBlocker";
  applicationId?: Maybe<Scalars["ID"]>;
  code: Scalars["String"];
  jobId?: Maybe<Scalars["ID"]>;
  message: Scalars["String"];
  talentProfileId: Scalars["ID"];
  userId: Scalars["ID"];
};

export type AgencyTransferJob = {
  __typename?: "AgencyTransferJob";
  agencyApprovalState?: Maybe<Scalars["String"]>;
  agencyId?: Maybe<Scalars["ID"]>;
  commissionPercentage?: Maybe<Scalars["Float"]>;
  financialReferences: Scalars["JSON"];
  invoiceIds: Array<Scalars["ID"]>;
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
  paymentIds: Array<Scalars["ID"]>;
  paymentStatuses: Scalars["JSON"];
  state: Scalars["String"];
};

export type AgencyTransferPerson = {
  __typename?: "AgencyTransferPerson";
  applicationIds: Array<Scalars["ID"]>;
  blockers: Array<AgencyTransferBlocker>;
  jobs: Array<AgencyTransferJob>;
  name: Scalars["String"];
  talentProfileId: Scalars["ID"];
  userId: Scalars["ID"];
  warnings: Array<Scalars["String"]>;
};

export type AgencyTransferPreview = {
  __typename?: "AgencyTransferPreview";
  blockers: Array<AgencyTransferBlocker>;
  destinationAgencyId: Scalars["ID"];
  people: Array<AgencyTransferPerson>;
  sourceAgencyId: Scalars["ID"];
  talentProfileIds: Array<Scalars["ID"]>;
  version: Scalars["String"];
};

export type AgentInvitation = {
  __typename?: "AgentInvitation";
  agencyName?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  email: Scalars["String"];
  firstParty: Scalars["Boolean"];
  id: Scalars["ID"];
};

export type AgentOnboarding = {
  __typename?: "AgentOnboarding";
  firstParty: Scalars["Boolean"];
};

export type AgentProfile = {
  __typename?: "AgentProfile";
  assets: Array<Asset>;
  id: Scalars["ID"];
  isChatroomAdmin?: Maybe<Scalars["Boolean"]>;
  isCurator?: Maybe<Scalars["Boolean"]>;
  role: Scalars["String"];
};

export enum AgentProfileRole {
  Manager = "MANAGER",
  Owner = "OWNER",
}

export type Asset = {
  __typename?: "Asset";
  height?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  kind: AssetKind;
  mediaUrl: Scalars["String"];
  signedId: Scalars["String"];
  sortWeight: Scalars["Int"];
  validUntil?: Maybe<Scalars["ISO8601DateTime"]>;
  width?: Maybe<Scalars["Int"]>;
};

export type AssetFileUploadInput = {
  file?: InputMaybe<FileUploadInput>;
  kind: AssetKind;
};

export enum AssetKind {
  Featured = "FEATURED",
  Image = "IMAGE",
  Logo = "LOGO",
  Polaroid = "POLAROID",
  Video = "VIDEO",
}

export type Auth = {
  __typename?: "Auth";
  jwt?: Maybe<Scalars["String"]>;
  unauthorized: Scalars["Boolean"];
};

export type AuthSso = {
  __typename?: "AuthSso";
  jwt?: Maybe<Scalars["String"]>;
  unauthorized: Scalars["Boolean"];
};

export type BankAccount = {
  __typename?: "BankAccount";
  accountNumber?: Maybe<Scalars["String"]>;
  iban?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  kind?: Maybe<BankAccountKind>;
  maskedIdentifier: Scalars["String"];
  ownerName: Scalars["String"];
  sortCode?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["ISO8601DateTime"];
};

export type BankAccountChangeChallenge = {
  __typename?: "BankAccountChangeChallenge";
  expiresAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  resendAvailableAt: Scalars["ISO8601DateTime"];
};

export enum BankAccountKind {
  Domestic = "DOMESTIC",
  International = "INTERNATIONAL",
}

export type BillingCompany = {
  __typename?: "BillingCompany";
  accountName: Scalars["String"];
  accountNumber: Scalars["String"];
  bankName: Scalars["String"];
  companyName: Scalars["String"];
  id: Scalars["ID"];
  invoicePrefix: Scalars["String"];
  isDefault: Scalars["Boolean"];
  name: Scalars["String"];
  officeAddress: Scalars["String"];
  sortCode: Scalars["String"];
  vatNumber?: Maybe<Scalars["String"]>;
  vatRegistered: Scalars["Boolean"];
  website: Scalars["String"];
};

export type BookerInvitation = {
  __typename?: "BookerInvitation";
  bookingCompanyName: Scalars["String"];
  createdAt: Scalars["ISO8601DateTime"];
  email: Scalars["String"];
  id: Scalars["ID"];
  isExistingAccount: Scalars["Boolean"];
};

export type BookerProfile = {
  __typename?: "BookerProfile";
  autoApprovalDisabled?: Maybe<Scalars["Boolean"]>;
  bookingCompany: BookingCompany;
  brands: Array<Scalars["String"]>;
  company: Scalars["String"];
  id: Scalars["ID"];
  invoiceBillingAddress?: Maybe<Scalars["String"]>;
  invoiceBillingName?: Maybe<Scalars["String"]>;
  kind?: Maybe<Scalars["String"]>;
  paymentDetails?: Maybe<PaymentDetails>;
  role?: Maybe<Scalars["String"]>;
  savedTalent?: Maybe<SavedTalentConnection>;
  savedTalentCollection?: Maybe<SavedTalentCollection>;
  savedTalentCollections?: Maybe<SavedTalentCollectionConnection>;
  talentCollectionMemberships?: Maybe<Array<SavedTalentCollection>>;
  website?: Maybe<Scalars["String"]>;
};

export type BookerProfileSavedTalentArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortColumn?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type BookerProfileSavedTalentCollectionArgs = {
  id: Scalars["ID"];
};

export type BookerProfileSavedTalentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type BookerProfileTalentCollectionMembershipsArgs = {
  id: Scalars["ID"];
};

export type BookingCompany = {
  __typename?: "BookingCompany";
  billingContact?: Maybe<Scalars["String"]>;
  billingDetailsPresent?: Maybe<Scalars["Boolean"]>;
  bookerInvitations?: Maybe<Array<BookerInvitation>>;
  companyEmailAddress?: Maybe<Scalars["String"]>;
  companyRegistrationNumber?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  freelancer?: Maybe<Scalars["Boolean"]>;
  id?: Maybe<Scalars["ID"]>;
  invoices?: Maybe<Array<Invoice>>;
  jobCount?: Maybe<Scalars["Int"]>;
  jobs?: Maybe<JobsConnection>;
  memberCount?: Maybe<Scalars["Int"]>;
  members?: Maybe<Array<User>>;
  name?: Maybe<Scalars["String"]>;
  notes?: Maybe<Array<Note>>;
  phoneNumber?: Maybe<Scalars["String"]>;
  registeredAddress?: Maybe<Address>;
  tradingAddress?: Maybe<Address>;
  waiveInvoiceFee?: Maybe<Scalars["Boolean"]>;
};

export type BookingCompanyJobsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<JobFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

/** The connection type for BookingCompany. */
export type BookingCompanyConnection = {
  __typename?: "BookingCompanyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BookingCompanyEdge>>>;
  /** A list of nodes. */
  nodes: Array<BookingCompany>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type BookingCompanyEdge = {
  __typename?: "BookingCompanyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: BookingCompany;
};

export type CastingRequest = {
  __typename?: "CastingRequest";
  canEdit: Scalars["Boolean"];
  canRemind: Scalars["Boolean"];
  canRespond: Scalars["Boolean"];
  cancelledAt?: Maybe<Scalars["ISO8601DateTime"]>;
  helpRequestedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  helpResolvedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  history: Scalars["JSON"];
  id: Scalars["ID"];
  instructions?: Maybe<Scalars["String"]>;
  jobTalentId?: Maybe<Scalars["ID"]>;
  location: Scalars["String"];
  overdue: Scalars["Boolean"];
  proposedAt: Scalars["ISO8601DateTime"];
  replyDeadlineAt: Scalars["ISO8601DateTime"];
  respondedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  respondedBy?: Maybe<User>;
  responseNote?: Maybe<Scalars["String"]>;
  revision: Scalars["Int"];
  status: Scalars["String"];
  talentId: Scalars["ID"];
  timeZone: Scalars["String"];
};

export type Chatroom = {
  __typename?: "Chatroom";
  archivedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  canPost: Scalars["Boolean"];
  chatroomParticipants?: Maybe<Array<ChatroomParticipant>>;
  createdAt: Scalars["ISO8601DateTime"];
  helpHistory: Scalars["JSON"];
  helpRequestedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  helpResolvedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  id: Scalars["ID"];
  job?: Maybe<Job>;
  kind?: Maybe<ChatroomKind>;
  lastSentAt: Scalars["ISO8601DateTime"];
  messages?: Maybe<MessageConnection>;
  name: Scalars["String"];
  newMessage?: Maybe<Scalars["Boolean"]>;
  newMessageStartAt?: Maybe<Scalars["ISO8601DateTime"]>;
  participants?: Maybe<Array<User>>;
};

export type ChatroomMessagesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** The connection type for Chatroom. */
export type ChatroomConnection = {
  __typename?: "ChatroomConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChatroomEdge>>>;
  /** A list of nodes. */
  nodes: Array<Chatroom>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type ChatroomEdge = {
  __typename?: "ChatroomEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Chatroom;
};

export type ChatroomFilterInput = {
  isArchived?: InputMaybe<Scalars["Boolean"]>;
  jobId?: InputMaybe<Scalars["ID"]>;
  kind?: InputMaybe<ChatroomKind>;
  searchText?: InputMaybe<Scalars["String"]>;
};

export enum ChatroomKind {
  Broadcast = "BROADCAST",
  Confirmed = "CONFIRMED",
}

export type ChatroomParticipant = {
  __typename?: "ChatroomParticipant";
  isAdmin: Scalars["Boolean"];
  isObserver: Scalars["Boolean"];
  participant?: Maybe<User>;
};

export type CommissionBreakdown = {
  __typename?: "CommissionBreakdown";
  additionalCommissionFee?: Maybe<Scalars["String"]>;
  agencyCommissionFee?: Maybe<Scalars["String"]>;
  contactFee?: Maybe<Scalars["String"]>;
  platformFee?: Maybe<Scalars["String"]>;
  transactionFee?: Maybe<Scalars["String"]>;
};

export enum CompanyHeadcountEstimate {
  AboveFiveHundred = "ABOVE_FIVE_HUNDRED",
  FiftyOneToOneHundred = "FIFTY_ONE_TO_ONE_HUNDRED",
  OneHundredOneToFiveHundred = "ONE_HUNDRED_ONE_TO_FIVE_HUNDRED",
  OneToFive = "ONE_TO_FIVE",
  SixToTwenty = "SIX_TO_TWENTY",
  TwentyOneToFifty = "TWENTY_ONE_TO_FIFTY",
}

export enum Complexion {
  FitzpatrickI = "FITZPATRICK_I",
  FitzpatrickIi = "FITZPATRICK_II",
  FitzpatrickIii = "FITZPATRICK_III",
  FitzpatrickIv = "FITZPATRICK_IV",
  FitzpatrickV = "FITZPATRICK_V",
  FitzpatrickVi = "FITZPATRICK_VI",
}

export type ComplexionOption = {
  __typename?: "ComplexionOption";
  colour: Scalars["String"];
  description: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["String"];
};

export type Component = {
  __typename?: "Component";
  name: Scalars["String"];
  props?: Maybe<ComponentProps>;
};

export type ComponentOption = {
  __typename?: "ComponentOption";
  label: Scalars["String"];
  value: Scalars["String"];
};

export type ComponentProps = {
  __typename?: "ComponentProps";
  checkboxOptions?: Maybe<Array<Scalars["String"]>>;
  label?: Maybe<Scalars["String"]>;
  placeholder?: Maybe<Scalars["String"]>;
  selectOptions?: Maybe<Array<ComponentOption>>;
};

/** Autogenerated return type of ConnectInstagram */
export type ConnectInstagramPayload = {
  __typename?: "ConnectInstagramPayload";
  socialMediaField?: Maybe<SocialMedia>;
};

export type ContactBankAccount = {
  __typename?: "ContactBankAccount";
  bankAccountName?: Maybe<Scalars["String"]>;
  bankAccountNumber?: Maybe<Scalars["String"]>;
  bankBic?: Maybe<Scalars["String"]>;
  bankIban?: Maybe<Scalars["String"]>;
  bankSortCode?: Maybe<Scalars["String"]>;
};

export type ContactFeeBreakdown = {
  __typename?: "ContactFeeBreakdown";
  bookingFee?: Maybe<Scalars["String"]>;
  invoiceFee?: Maybe<Scalars["String"]>;
  platformFee?: Maybe<Scalars["String"]>;
  transactionFee?: Maybe<Scalars["String"]>;
  vat?: Maybe<Scalars["String"]>;
};

export enum ConversionType {
  Centimeters = "CENTIMETERS",
  EuShoe = "EU_SHOE",
  FeetAndInches = "FEET_AND_INCHES",
  Inches = "INCHES",
  MetersAndCentimeters = "METERS_AND_CENTIMETERS",
  UkShoe = "UK_SHOE",
}

export type CounterOffer = {
  __typename?: "CounterOffer";
  amount: Scalars["Float"];
  answeredAt?: Maybe<Scalars["ISO8601DateTime"]>;
  createdAt: Scalars["ISO8601DateTime"];
  currency: Scalars["String"];
  id: Scalars["ID"];
  note?: Maybe<Scalars["String"]>;
  proposerRole: CounterOfferProposer;
  state: CounterOfferState;
};

export enum CounterOfferDecision {
  Accept = "ACCEPT",
  Decline = "DECLINE",
  FinalFee = "FINAL_FEE",
}

export enum CounterOfferProposer {
  Client = "CLIENT",
  Talent = "TALENT",
}

export enum CounterOfferState {
  Accepted = "ACCEPTED",
  Closed = "CLOSED",
  Declined = "DECLINED",
  Open = "OPEN",
  Superseded = "SUPERSEDED",
  Withdrawn = "WITHDRAWN",
}

export type CreateAgencyInput = {
  location: Scalars["String"];
  logo?: InputMaybe<FileUploadInput>;
  name: Scalars["String"];
  paymentsEmail: Scalars["String"];
};

export type CreateJobVerticalInput = {
  budget: Scalars["Float"];
  deliverables?: InputMaybe<Array<Scalars["String"]>>;
  initialBudget?: InputMaybe<Scalars["Float"]>;
  jobLength?: InputMaybe<Scalars["String"]>;
  suggestedBudget?: InputMaybe<Scalars["Float"]>;
  talentRequired: Scalars["Int"];
  timeslots?: InputMaybe<Array<TimeslotInput>>;
  vertical: TalentVertical;
};

export type CreatePackageVerticalInput = {
  budget?: InputMaybe<Scalars["Float"]>;
  deliverables?: InputMaybe<Array<Scalars["String"]>>;
  jobLength?: InputMaybe<Scalars["String"]>;
  talentRequired?: InputMaybe<Scalars["Int"]>;
  vertical: TalentVertical;
};

export type CreateTalentProfileInput = {
  additionalLocations?: InputMaybe<Array<TalentLocationInput>>;
  agencyId?: InputMaybe<Scalars["ID"]>;
  biography?: InputMaybe<Scalars["String"]>;
  contract?: InputMaybe<FileUploadInput>;
  dateOfBirth: Scalars["ISO8601Date"];
  dietaryRequirements?: InputMaybe<Array<Scalars["String"]>>;
  gender: Gender;
  hobbies?: InputMaybe<Array<Scalars["String"]>>;
  instagramUsername?: InputMaybe<Scalars["String"]>;
  isContactLaunch?: InputMaybe<Scalars["Boolean"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]>;
  minDayRate?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  pastClients?: InputMaybe<Array<Scalars["String"]>>;
  portfolioImages?: InputMaybe<Array<PortfolioImageInput>>;
  primaryLocation: TalentLocationInput;
  pronouns?: InputMaybe<Pronouns>;
  published?: InputMaybe<Scalars["Boolean"]>;
  shrineAssets?: InputMaybe<Array<AssetFileUploadInput>>;
  socialMediaFields?: InputMaybe<Array<SocialMediaInput>>;
  vertical: TalentVertical;
  verticalData?: InputMaybe<Scalars["JSON"]>;
  website?: InputMaybe<Scalars["String"]>;
  yearsExperience?: InputMaybe<Scalars["Int"]>;
};

export enum DataType {
  Integer = "INTEGER",
  String = "STRING",
}

export type DateRangeInput = {
  endDate: Scalars["ISO8601Date"];
  startDate: Scalars["ISO8601Date"];
};

export type DeckFile = {
  __typename?: "DeckFile";
  contentType?: Maybe<Scalars["String"]>;
  filename: Scalars["String"];
  id: Scalars["ID"];
  size?: Maybe<Scalars["Int"]>;
  url: Scalars["String"];
};

/** Autogenerated return type of DeleteBillingCompany */
export type DeleteBillingCompanyPayload = {
  __typename?: "DeleteBillingCompanyPayload";
  success: Scalars["Boolean"];
};

/** Autogenerated return type of DisconnectInstagram */
export type DisconnectInstagramPayload = {
  __typename?: "DisconnectInstagramPayload";
  success: Scalars["Boolean"];
};

export enum EmailCopySlotKind {
  Body = "BODY",
  Subject = "SUBJECT",
}

export type EmailHealth = {
  __typename?: "EmailHealth";
  /** Sends that failed permanently. */
  bounced: Scalars["Int"];
  /** Tracked sends clicked at least once. Indicative. */
  clicked: Scalars["Int"];
  /** Sends the recipient marked as spam. */
  complained: Scalars["Int"];
  delivered: Scalars["Int"];
  /** The latest send, however long ago. */
  lastSentAt?: Maybe<Scalars["ISO8601DateTime"]>;
  /** Tracked sends opened at least once. Approximate. */
  opened: Scalars["Int"];
  sent: Scalars["Int"];
  /** Sends with open and click tracking on: what opens and clicks count against. */
  tracked: Scalars["Int"];
};

export type EmailPreview = {
  __typename?: "EmailPreview";
  authoringPolicy: Scalars["String"];
  /** Published copy reaches recipients. While false, every transactional send uses the code defaults instead. */
  copyPublishingLive: Scalars["Boolean"];
  displayName: Scalars["String"];
  /** Its copy has an unpublished draft. */
  draftPending: Scalars["Boolean"];
  /** The unpublished draft. */
  draftRevision?: Maybe<EmailRevisionSummary>;
  family: Scalars["String"];
  /** Every template a change to this copy reaches. */
  fanOut: Array<Scalars["String"]>;
  /** Delivery over the last 30 days. */
  health: EmailHealth;
  html?: Maybe<Scalars["String"]>;
  /** The published copy; none until the first save. */
  liveRevision?: Maybe<EmailRevisionSummary>;
  name: Scalars["String"];
  ported: Scalars["Boolean"];
  /** Fields whose code default changed after the live revision was taken. */
  shadowedSlots: Array<EmailShadowedSlot>;
  /** The consent topic every send of it falls under. */
  topic: EmailTopic;
  trigger: Scalars["String"];
  /** Every template this copy renders into, each with both parts and every subject. */
  variants: Array<EmailVariant>;
};

export enum EmailRevisionState {
  Draft = "DRAFT",
  Published = "PUBLISHED",
  Superseded = "SUPERSEDED",
}

export type EmailRevisionSummary = {
  __typename?: "EmailRevisionSummary";
  changeNote?: Maybe<Scalars["String"]>;
  number: Scalars["Int"];
  publishedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  /** The publisher's admin address. None for the original wording, which nobody published. */
  publishedBy?: Maybe<Scalars["String"]>;
  state: EmailRevisionState;
  /** When a draft was last saved. */
  updatedAt: Scalars["ISO8601DateTime"];
  /** The admin address that last saved a draft. */
  updatedBy?: Maybe<Scalars["String"]>;
};

export type EmailShadowedSlot = {
  __typename?: "EmailShadowedSlot";
  /** The wording in the code now. */
  currentDefault?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  kind: EmailCopySlotKind;
  /** What the live revision sends instead. */
  published?: Maybe<Scalars["String"]>;
};

export type EmailSubject = {
  __typename?: "EmailSubject";
  error?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  /** Nil when it cannot be rendered; error says why. */
  subject?: Maybe<Scalars["String"]>;
};

export type EmailTemplate = {
  __typename?: "EmailTemplate";
  authoringPolicy: Scalars["String"];
  displayName: Scalars["String"];
  /** Its copy has an unpublished draft. */
  draftPending: Scalars["Boolean"];
  family: Scalars["String"];
  /** Delivery over the last 30 days. */
  health: EmailHealth;
  name: Scalars["String"];
  ported: Scalars["Boolean"];
  /** The consent topic every send of it falls under. */
  topic: EmailTopic;
  trigger: Scalars["String"];
};

export enum EmailTopic {
  Marketing = "MARKETING",
  Service = "SERVICE",
}

export type EmailVariant = {
  __typename?: "EmailVariant";
  displayName: Scalars["String"];
  /** Nil when the template cannot be rendered; renderError says why. */
  html?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  renderError?: Maybe<Scalars["String"]>;
  subjects: Array<EmailSubject>;
  /** The plain-text part. */
  text?: Maybe<Scalars["String"]>;
};

/** Autogenerated return type of EnhanceJobBrief */
export type EnhanceJobBriefPayload = {
  __typename?: "EnhanceJobBriefPayload";
  enhancedDescription?: Maybe<Scalars["String"]>;
  errors: Array<Scalars["String"]>;
};

export enum EyeColour {
  Blue = "BLUE",
  Brown = "BROWN",
  Green = "GREEN",
  Grey = "GREY",
}

export type FeeItem = {
  __typename?: "FeeItem";
  amount: Scalars["Float"];
  description: Scalars["String"];
  kind: FeeKind;
};

export enum FeeKind {
  BookingFee = "BOOKING_FEE",
  InvoiceFee = "INVOICE_FEE",
  PlatformFee = "PLATFORM_FEE",
  TransactionFee = "TRANSACTION_FEE",
}

export type Field = {
  __typename?: "Field";
  dataType: DataType;
  excludedGenders?: Maybe<Array<Gender>>;
  filterable: Scalars["Boolean"];
  inputType?: Maybe<InputType>;
  key: Scalars["String"];
  label: Scalars["String"];
  maxValue?: Maybe<Scalars["Int"]>;
  minValue?: Maybe<Scalars["Int"]>;
  multiple: Scalars["Boolean"];
  name: Scalars["String"];
  options?: Maybe<Array<FieldOption>>;
  required?: Maybe<Scalars["Boolean"]>;
  requiredGenders?: Maybe<Array<Gender>>;
  unit?: Maybe<Scalars["String"]>;
};

export type FieldOption = {
  __typename?: "FieldOption";
  colour?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  icon?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  value: Scalars["String"];
};

export type FileUploadInput = {
  contentLength?: InputMaybe<Scalars["Int"]>;
  contentType: Scalars["String"];
  filename: Scalars["String"];
  key: Scalars["ID"];
};

export type Filter = {
  __typename?: "Filter";
  checkedValue?: Maybe<Scalars["String"]>;
  childFilters?: Maybe<Array<Filter>>;
  contexts: Array<FilterContext>;
  dataType?: Maybe<DataType>;
  defaultOptions?: Maybe<Array<Scalars["String"]>>;
  excludedGenders?: Maybe<Array<Gender>>;
  expanded?: Maybe<Scalars["Boolean"]>;
  expandedTitleFilter?: Maybe<Filter>;
  helperText?: Maybe<Scalars["String"]>;
  imperialMeasurementDisplay?: Maybe<MeasurementDisplay>;
  isClearable: Scalars["Boolean"];
  kind: FilterKind;
  label: Scalars["String"];
  labelChecked?: Maybe<Scalars["String"]>;
  labelUnchecked?: Maybe<Scalars["String"]>;
  maxValue?: Maybe<Scalars["Int"]>;
  metricMeasurementDisplay?: Maybe<MeasurementDisplay>;
  minValue?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  options?: Maybe<Array<FilterOption>>;
  preferenceName?: Maybe<Scalars["String"]>;
  rangeLabelPrefix?: Maybe<Scalars["String"]>;
  uncheckedValue?: Maybe<Scalars["String"]>;
  verticalSpecific: Scalars["Boolean"];
};

export enum FilterContext {
  CreateAJob = "CREATE_A_JOB",
  PackageShortlist = "PACKAGE_SHORTLIST",
  TalentManagement = "TALENT_MANAGEMENT",
}

export enum FilterKind {
  FilterGroup = "FILTER_GROUP",
  MultiSelect = "MULTI_SELECT",
  Range = "RANGE",
  Select = "SELECT",
  Text = "TEXT",
  Toggle = "TOGGLE",
}

export type FilterOption = {
  __typename?: "FilterOption";
  colour?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  value: Scalars["String"];
};

export type FilterOptions = {
  __typename?: "FilterOptions";
  bustSize: Measurement;
  chestSize: Measurement;
  complexions: Array<ComplexionOption>;
  dietaryRequirements: Array<LabelValueOption>;
  eyeColours: Array<OptionTypeWithColour>;
  genders: Array<LabelValueOption>;
  hairColours: Array<OptionTypeWithColour>;
  hairStyles: Array<LabelValueOption>;
  height: Measurement;
  hipSize: Measurement;
  hobbies: Array<LabelValueOption>;
  legLength: Measurement;
  shoeSize: Measurement;
  suitSize: Measurement;
  waistSize: Measurement;
};

export enum Gender {
  Female = "FEMALE",
  Male = "MALE",
  NonBinary = "NON_BINARY",
}

export type Group = {
  __typename?: "Group";
  id: Scalars["ID"];
  manuallySet: Scalars["Boolean"];
  name: Scalars["String"];
};

export enum HairColour {
  Black = "BLACK",
  Blond = "BLOND",
  Brown = "BROWN",
  Grey = "GREY",
  Other = "OTHER",
  Red = "RED",
}

export enum HairStyle {
  Bald = "BALD",
  Long = "LONG",
  Medium = "MEDIUM",
  ReligiousHeaddress = "RELIGIOUS_HEADDRESS",
  Short = "SHORT",
}

export enum HeadcountEstimate {
  AboveThirty = "ABOVE_THIRTY",
  ElevenToTwenty = "ELEVEN_TO_TWENTY",
  SixToTen = "SIX_TO_TEN",
  TwentyOneToThirty = "TWENTY_ONE_TO_THIRTY",
  ZeroToFive = "ZERO_TO_FIVE",
}

export enum InputType {
  MultiCheckbox = "MULTI_CHECKBOX",
  MultiSelect = "MULTI_SELECT",
  Radio = "RADIO",
  RadioSelect = "RADIO_SELECT",
  Range = "RANGE",
  Select = "SELECT",
  Text = "TEXT",
}

export type Invoice = {
  __typename?: "Invoice";
  billingCompany?: Maybe<BillingCompany>;
  billingCompanyId?: Maybe<Scalars["ID"]>;
  currency: Scalars["String"];
  dueDate: Scalars["ISO8601Date"];
  feeItems?: Maybe<Array<FeeItem>>;
  hasSentLatePaymentInvoice: Scalars["Boolean"];
  id: Scalars["ID"];
  invoiceDate: Scalars["ISO8601Date"];
  invoiceNumber?: Maybe<Scalars["String"]>;
  isJobPaymentInvoice: Scalars["Boolean"];
  isLatePaymentInvoice: Scalars["Boolean"];
  issuerDetails?: Maybe<InvoiceIssuerDetails>;
  job?: Maybe<Job>;
  overdue: Scalars["Boolean"];
  paidAt?: Maybe<Scalars["ISO8601DateTime"]>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentReference?: Maybe<Scalars["String"]>;
  pdfUrl?: Maybe<Scalars["String"]>;
  poNumber?: Maybe<Scalars["String"]>;
  reissues?: Maybe<Array<InvoiceReissue>>;
  state: InvoiceState;
  subtotal?: Maybe<Scalars["Float"]>;
  total?: Maybe<Scalars["Float"]>;
  trustshareProjectId?: Maybe<Scalars["String"]>;
  xeroReference?: Maybe<Scalars["String"]>;
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: "InvoiceConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes: Array<Invoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: "InvoiceEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Invoice;
};

export type InvoiceFilterInput = {
  dueDateEnd?: InputMaybe<Scalars["ISO8601Date"]>;
  dueDateStart?: InputMaybe<Scalars["ISO8601Date"]>;
  invoiceNumber?: InputMaybe<Scalars["String"]>;
  jobName?: InputMaybe<Scalars["String"]>;
  overdue?: InputMaybe<Scalars["Boolean"]>;
  states?: InputMaybe<Array<InvoiceState>>;
};

export type InvoiceIssuerDetails = {
  __typename?: "InvoiceIssuerDetails";
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  invoicePrefix: Scalars["String"];
  vatNumber?: Maybe<Scalars["String"]>;
  vatRegistered: Scalars["Boolean"];
};

export type InvoiceReissue = {
  __typename?: "InvoiceReissue";
  clientNotified: Scalars["Boolean"];
  createdAt: Scalars["ISO8601DateTime"];
  previousCompanyName?: Maybe<Scalars["String"]>;
  previousInvoiceNumber: Scalars["String"];
  previousTotal?: Maybe<Scalars["Float"]>;
};

export enum InvoiceState {
  Paid = "PAID",
  PaymentIntentCreated = "PAYMENT_INTENT_CREATED",
  Pending = "PENDING",
  Processing = "PROCESSING",
  ReadyToPay = "READY_TO_PAY",
  Refunded = "REFUNDED",
}

export type Job = {
  __typename?: "Job";
  activityStream?: Maybe<ActivityLogConnection>;
  additionalFeesAmount?: Maybe<Scalars["Float"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  affiliate?: Maybe<JobAffiliate>;
  agencyApprovalState?: Maybe<JobAgencyState>;
  agencyBrief: AgencyBrief;
  agencyBriefPreview?: Maybe<AgencyBrief>;
  agencyDecisionReady: Scalars["Boolean"];
  agencyJobState?: Maybe<AgencyJobState>;
  agencyQuestions: Array<JobAgencyQuestion>;
  allTravelFeesCovered: Scalars["Boolean"];
  archived: Scalars["Boolean"];
  assignedAgent?: Maybe<JobAssignee>;
  /** @deprecated Use assignedAgent instead */
  assignee?: Maybe<User>;
  awaitingPayment?: Maybe<Scalars["Boolean"]>;
  bloomActivatedAtForCurrentUser?: Maybe<Scalars["ISO8601DateTime"]>;
  bloomFeePercentage: Scalars["Float"];
  booker?: Maybe<User>;
  bookingCompany?: Maybe<BookingCompany>;
  brand: Scalars["String"];
  budget: Scalars["Float"];
  canReview: Scalars["Boolean"];
  cancellationNote?: Maybe<Scalars["String"]>;
  cancellationReason?: Maybe<JobCancellationReason>;
  cancelledAt?: Maybe<Scalars["ISO8601DateTime"]>;
  castingCloseImpact: Array<JobTalent>;
  castingOpen: Scalars["Boolean"];
  castingRequests: Array<CastingRequest>;
  cateringProvided?: Maybe<Scalars["Boolean"]>;
  city?: Maybe<Scalars["String"]>;
  /** @deprecated use commissionForUser or totalCommission */
  commission?: Maybe<Scalars["Float"]>;
  commissionForUser?: Maybe<Scalars["Float"]>;
  completedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  confirmedTalentCount: Scalars["Int"];
  conflicts?: Maybe<Array<JobConflict>>;
  counterOfferForCurrentUser?: Maybe<CounterOffer>;
  country?: Maybe<Scalars["String"]>;
  county?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  creativeCounts: Array<JobCreativeCount>;
  creativeCountsByVertical: Array<JobVerticalCount>;
  currency: Scalars["String"];
  deckFiles?: Maybe<Array<DeckFile>>;
  deliverables: Array<Scalars["String"]>;
  description: Scalars["String"];
  endDate?: Maybe<Scalars["ISO8601Date"]>;
  excludeVat?: Maybe<Scalars["Boolean"]>;
  expensesAmount?: Maybe<Scalars["Float"]>;
  expiresOn?: Maybe<Scalars["ISO8601DateTime"]>;
  extraFeesAmount?: Maybe<Scalars["Float"]>;
  feeForCurrentUser?: Maybe<Scalars["Float"]>;
  feeItems?: Maybe<Array<FeeItem>>;
  finalizedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  fullAddress?: Maybe<Scalars["String"]>;
  hasUnresolvedDisputes?: Maybe<Scalars["Boolean"]>;
  headcountEstimate?: Maybe<HeadcountEstimate>;
  id: Scalars["ID"];
  imagesReceived?: Maybe<Scalars["Boolean"]>;
  /** @deprecated For backwards compatibility */
  inboundPayment?: Maybe<Scalars["String"]>;
  invoiceBillingAddress?: Maybe<Scalars["String"]>;
  invoiceBillingName?: Maybe<Scalars["String"]>;
  invoiceFeeWithoutVat?: Maybe<Scalars["Float"]>;
  invoices?: Maybe<Array<Invoice>>;
  jobDisputes?: Maybe<Array<JobDispute>>;
  jobLength?: Maybe<Scalars["String"]>;
  /** @deprecated replaced by :talent, for backwards compatibility with api types */
  jobTalent: Array<JobTalent>;
  jobVerticals: Array<JobVertical>;
  kind: JobKind;
  latestPaidInvoices?: Maybe<Array<Invoice>>;
  latitude?: Maybe<Scalars["Float"]>;
  location?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["Float"]>;
  modelsRequired: Scalars["Int"];
  name: Scalars["String"];
  notes?: Maybe<Array<Note>>;
  nudityType?: Maybe<NudityInvolvement>;
  ownClientPackageId?: Maybe<Scalars["ID"]>;
  package?: Maybe<Package>;
  payableInvoices?: Maybe<Array<Invoice>>;
  paymentBreakdown?: Maybe<Array<JobPaymentAmount>>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentProcessing?: Maybe<Scalars["Boolean"]>;
  paymentReceived?: Maybe<Scalars["Boolean"]>;
  paymentViaExternalPlatform?: Maybe<Scalars["Boolean"]>;
  payments?: Maybe<Array<OutboundPayment>>;
  postcode?: Maybe<Scalars["String"]>;
  preApprovalShortlistCount?: Maybe<Scalars["Int"]>;
  prebookingCoordinationEnabled: Scalars["Boolean"];
  rejectionNote?: Maybe<Scalars["String"]>;
  rejectionReason?: Maybe<JobRejectionReason>;
  requiredTalentCount: Scalars["Int"];
  selfTapeRequired?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Jobs are no longer limited to single verticals, see JobVerticals entity for vertical specific details */
  shortlistCount: Scalars["Int"];
  slug: Scalars["String"];
  spansMultipleDays: Scalars["Boolean"];
  startDate?: Maybe<Scalars["ISO8601Date"]>;
  state: JobState;
  stateForCurrentUser: JobTalentState;
  talent?: Maybe<Array<JobTalent>>;
  talentBloomEligibility?: Maybe<Scalars["Boolean"]>;
  talentBloomFee?: Maybe<Scalars["Float"]>;
  talentPaymentGuide?: Maybe<TalentPaymentGuide>;
  talentRequired: Scalars["Int"];
  totalCommission?: Maybe<Scalars["Float"]>;
  totalInvoiceCount?: Maybe<Scalars["Int"]>;
  totalPayable?: Maybe<Scalars["Float"]>;
  totalPayableTalentFee?: Maybe<Scalars["Float"]>;
  tpaAdditionalFeesCommission?: Maybe<Scalars["Float"]>;
  tpaBloomEligibility?: Maybe<Scalars["Boolean"]>;
  tpaBookingFee?: Maybe<Scalars["Float"]>;
  tpaTalentCommission?: Maybe<Scalars["Float"]>;
  transitionableStates: Array<Scalars["String"]>;
  travelExpenseCover?: Maybe<Scalars["Float"]>;
  trustshareProjectId?: Maybe<Scalars["String"]>;
  unpaidInvoiceCount?: Maybe<Scalars["Int"]>;
  unpaidLineItems?: Maybe<Array<LineItem>>;
  usage?: Maybe<Scalars["String"]>;
  usages?: Maybe<Array<Usage>>;
  variableFeesEnabled: Scalars["Boolean"];
  vatAmount?: Maybe<Scalars["Float"]>;
  /** @deprecated Jobs are no longer limited to single verticals, see JobVerticals entity for vertical specific details */
  vertical: TalentVertical;
  virtual: Scalars["Boolean"];
};

export type JobActivityStreamArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export enum JobAffiliate {
  Depop = "depop",
}

export type JobAgency = {
  __typename?: "JobAgency";
  agency: Agency;
  id: Scalars["ID"];
  isPaid: Scalars["Boolean"];
  job: Job;
  paidAt?: Maybe<Scalars["ISO8601DateTime"]>;
  state: JobAgencyState;
};

export type JobAgencyInput = {
  id: Scalars["ID"];
  isPaid?: InputMaybe<Scalars["Boolean"]>;
};

export type JobAgencyQuestion = {
  __typename?: "JobAgencyQuestion";
  agencyName?: Maybe<Scalars["String"]>;
  answeredAt?: Maybe<Scalars["ISO8601DateTime"]>;
  approvedAnswer?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  question: Scalars["String"];
  state: Scalars["String"];
};

export enum JobAgencyState {
  Approved = "APPROVED",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type JobApplication = {
  __typename?: "JobApplication";
  answers: Array<JobApplicationAnswer>;
  applicationRoles: Array<JobApplicationVertical>;
  assets: Array<Asset>;
  createdAt: Scalars["ISO8601DateTime"];
  events: Array<JobApplicationEvent>;
  id: Scalars["ID"];
  jobTalent?: Maybe<JobTalent>;
  jobVerticals: Array<JobVertical>;
  note?: Maybe<Scalars["String"]>;
  openCall: OpenCall;
  profileSnapshot: Scalars["JSON"];
  rejectionReason?: Maybe<Scalars["String"]>;
  state: Scalars["String"];
  submittedAt: Scalars["ISO8601DateTime"];
  talent: User;
};

export type JobApplicationAnswer = {
  __typename?: "JobApplicationAnswer";
  id: Scalars["ID"];
  openCallQuestion: OpenCallQuestion;
  value: Scalars["JSON"];
};

/** The connection type for JobApplication. */
export type JobApplicationConnection = {
  __typename?: "JobApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobApplicationEdge>>>;
  /** A list of nodes. */
  nodes: Array<JobApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type JobApplicationEdge = {
  __typename?: "JobApplicationEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: JobApplication;
};

export type JobApplicationEvent = {
  __typename?: "JobApplicationEvent";
  actor?: Maybe<User>;
  createdAt: Scalars["ISO8601DateTime"];
  fromState?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  metadata: Scalars["JSON"];
  reason?: Maybe<Scalars["String"]>;
  toState: Scalars["String"];
};

export type JobApplicationVertical = {
  __typename?: "JobApplicationVertical";
  actionable: Scalars["Boolean"];
  agencyName?: Maybe<Scalars["String"]>;
  approvalRequired: Scalars["Boolean"];
  createdAt: Scalars["ISO8601DateTime"];
  endorsementDecidedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  endorsementReason?: Maybe<Scalars["String"]>;
  endorsementState: Scalars["String"];
  id: Scalars["ID"];
  jobVertical: JobVertical;
  note?: Maybe<Scalars["String"]>;
  openCall: OpenCall;
  representationMode: Scalars["String"];
  submittedAt: Scalars["ISO8601DateTime"];
  talent: User;
};

/** The connection type for JobApplicationVertical. */
export type JobApplicationVerticalConnection = {
  __typename?: "JobApplicationVerticalConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobApplicationVerticalEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobApplicationVertical>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type JobApplicationVerticalEdge = {
  __typename?: "JobApplicationVerticalEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node?: Maybe<JobApplicationVertical>;
};

export type JobAssignee = {
  __typename?: "JobAssignee";
  assignedLiveJobCount?: Maybe<Scalars["Int"]>;
  email: Scalars["String"];
  featuredAsset?: Maybe<Asset>;
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
};

export enum JobCancellationReason {
  BookedElsewhere = "BOOKED_ELSEWHERE",
  DateChanged = "DATE_CHANGED",
  JobNotHappening = "JOB_NOT_HAPPENING",
  Other = "OTHER",
  RatesTooHigh = "RATES_TOO_HIGH",
  UnavailableCreatives = "UNAVAILABLE_CREATIVES",
  UnresponsiveBooker = "UNRESPONSIVE_BOOKER",
  UnresponsiveCreatives = "UNRESPONSIVE_CREATIVES",
}

export type JobConflict = {
  __typename?: "JobConflict";
  conflictingJobs: Array<Job>;
  jobTalent: JobTalent;
};

export type JobCreationSchema = {
  __typename?: "JobCreationSchema";
  detailsFormFields: Array<Component>;
};

export type JobCreativeCount = {
  __typename?: "JobCreativeCount";
  confirmedCount: Scalars["Int"];
  pendingCount: Scalars["Int"];
  vertical: TalentVertical;
};

export type JobDispute = {
  __typename?: "JobDispute";
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  job: Job;
  reportedBy: User;
  resolvedBy?: Maybe<User>;
};

/** An edge in a connection. */
export type JobEdge = {
  __typename?: "JobEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Job;
};

export type JobFilterInput = {
  assigneeId?: InputMaybe<Scalars["ID"]>;
  brand?: InputMaybe<Scalars["String"]>;
  brands?: InputMaybe<Array<Scalars["String"]>>;
  dateRange?: InputMaybe<DateRangeInput>;
  jobType?: InputMaybe<Array<TalentVertical>>;
  name?: InputMaybe<Scalars["String"]>;
  nameOrBrand?: InputMaybe<Scalars["String"]>;
  states?: InputMaybe<Array<Scalars["String"]>>;
  talentName?: InputMaybe<Scalars["String"]>;
  verticals?: InputMaybe<Array<TalentVertical>>;
  withMessage?: InputMaybe<Scalars["Boolean"]>;
};

export enum JobKind {
  Campaign = "CAMPAIGN",
  Casting = "CASTING",
  Commercial = "COMMERCIAL",
  Ecom = "ECOM",
  Editorial = "EDITORIAL",
  Events = "EVENTS",
  FashionWeek = "FASHION_WEEK",
  Fitting = "FITTING",
  Gifting = "GIFTING",
  InfluencerBrief = "INFLUENCER_BRIEF",
  Lookbook = "LOOKBOOK",
  MusicVideo = "MUSIC_VIDEO",
  Other = "OTHER",
  StudentAndGradProject = "STUDENT_AND_GRAD_PROJECT",
  TestShoot = "TEST_SHOOT",
}

export type JobPaymentAmount = {
  __typename?: "JobPaymentAmount";
  agencyBreakdown?: Maybe<AgencyBreakdown>;
  amount: Scalars["Float"];
  bankAccount?: Maybe<BankAccount>;
  commissionBreakdown?: Maybe<CommissionBreakdown>;
  contactBankAccount?: Maybe<ContactBankAccount>;
  contactFeeBreakdown?: Maybe<ContactFeeBreakdown>;
  isAgencyPaid?: Maybe<Scalars["Boolean"]>;
  isPaid?: Maybe<Scalars["Boolean"]>;
  jobAgencyId?: Maybe<Scalars["ID"]>;
  jobTalentId?: Maybe<Scalars["ID"]>;
  recipientName: Scalars["String"];
  recipientType: Scalars["String"];
};

export enum JobPostCompletionAction {
  ImagesReceived = "IMAGES_RECEIVED",
  PaymentReceived = "PAYMENT_RECEIVED",
}

export enum JobRejectionReason {
  Covid_19 = "COVID_19",
  Generic = "GENERIC",
  InappropriateBudget = "INAPPROPRIATE_BUDGET",
  InsufficientInformation = "INSUFFICIENT_INFORMATION",
  NoTalent = "NO_TALENT",
}

export enum JobState {
  Approved = "APPROVED",
  AwaitingPayment = "AWAITING_PAYMENT",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Expired = "EXPIRED",
  Finalized = "FINALIZED",
  PendingApproval = "PENDING_APPROVAL",
  Rejected = "REJECTED",
}

export type JobTalent = {
  __typename?: "JobTalent";
  appliedThroughOpenCall: Scalars["Boolean"];
  assets?: Maybe<Array<Asset>>;
  bloomFee?: Maybe<Scalars["Float"]>;
  canPrebookingChat: Scalars["Boolean"];
  castingRequest?: Maybe<CastingRequest>;
  counterOffer?: Maybe<CounterOffer>;
  eligibleForBloom: Scalars["Boolean"];
  email?: Maybe<Scalars["String"]>;
  fee?: Maybe<Scalars["Float"]>;
  feeIsCustom?: Maybe<Scalars["Boolean"]>;
  firstPaidJob?: Maybe<Scalars["Boolean"]>;
  formattedRejectionReason?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isPaid: Scalars["Boolean"];
  job: Job;
  lineItems?: Maybe<Array<LineItem>>;
  name: Scalars["String"];
  /** @deprecated backwards compatibility with api types */
  notified?: Maybe<Scalars["Boolean"]>;
  notifiedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  nudgedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  outboundPayments?: Maybe<Array<OutboundPayment>>;
  paidAt?: Maybe<Scalars["ISO8601DateTime"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  profile: TalentProfile;
  rejectionNote?: Maybe<Scalars["String"]>;
  state: JobTalentState;
  talent: User;
  transitionableEvents: Array<JobTalentStateEvent>;
  transitionableStates: Array<JobTalentState>;
  userId: Scalars["ID"];
};

export type JobTalentInput = {
  id: Scalars["ID"];
  isPaid?: InputMaybe<Scalars["Boolean"]>;
};

export type JobTalentPriceBreakdown = {
  __typename?: "JobTalentPriceBreakdown";
  /** Total deductions from additional fees based on agency commission */
  additionalFeesDeductions: Scalars["Float"];
  /** The commission percentage set by the agency for the job */
  agencyCommissionPercentage?: Maybe<Scalars["Int"]>;
  /** The sum of talent's expenses */
  expensesAmount: Scalars["Float"];
  /** The sum of talent's additional fees without agency commission deductions. */
  grossAdditionalFees: Scalars["Float"];
  /** The talent's base fee without agency commission deductions. */
  grossTalentFee: Scalars["Float"];
  /** The talent's fee after all deductions */
  netFee: Scalars["Float"];
  /** Total deductions from talent's base fee based on agency commission */
  talentFeeDeductions: Scalars["Float"];
};

export enum JobTalentRejectionReason {
  BudgetTooLow = "BUDGET_TOO_LOW",
  Busy = "BUSY",
  DoesNotMatchBrief = "DOES_NOT_MATCH_BRIEF",
  JobDetails = "JOB_DETAILS",
  LateNotice = "LATE_NOTICE",
  LocationNotAccessible = "LOCATION_NOT_ACCESSIBLE",
  Other = "OTHER",
  UnwellPersonal = "UNWELL_PERSONAL",
  ValuesDoNotFit = "VALUES_DO_NOT_FIT",
}

export enum JobTalentState {
  Accepted = "ACCEPTED",
  AwaitingConfirmation = "AWAITING_CONFIRMATION",
  Confirmed = "CONFIRMED",
  Disputed = "DISPUTED",
  Paid = "PAID",
  Pending = "PENDING",
  PendingAgencyApproval = "PENDING_AGENCY_APPROVAL",
  Rejected = "REJECTED",
  RejectedByBooker = "REJECTED_BY_BOOKER",
}

export enum JobTalentStateEvent {
  Accept = "ACCEPT",
  Approve = "APPROVE",
  AwaitConfirmation = "AWAIT_CONFIRMATION",
  Confirm = "CONFIRM",
  Dispute = "DISPUTE",
  Pay = "PAY",
  Reject = "REJECT",
  RejectByBooker = "REJECT_BY_BOOKER",
}

export type JobVertical = {
  __typename?: "JobVertical";
  budget: Scalars["Float"];
  confirmedCount: Scalars["Int"];
  deliverables: Array<Scalars["String"]>;
  id: Scalars["ID"];
  jobLength?: Maybe<Scalars["String"]>;
  shortlistCount: Scalars["Int"];
  talentRequired: Scalars["Int"];
  timeslots?: Maybe<Array<Timeslot>>;
  vertical: TalentVertical;
};

export type JobVerticalCount = {
  __typename?: "JobVerticalCount";
  confirmedCount: Scalars["Int"];
  label: Scalars["String"];
  pendingCount: Scalars["Int"];
  vertical: Scalars["String"];
};

export enum JobWorkspace {
  Agency = "AGENCY",
  Booking = "BOOKING",
}

/** The connection type for Job. */
export type JobsConnection = {
  __typename?: "JobsConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobEdge>>>;
  /** A list of nodes. */
  nodes: Array<Job>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

export type KeyValue = {
  __typename?: "KeyValue";
  key: Scalars["String"];
  value: Scalars["String"];
};

export type LabelValueOption = {
  __typename?: "LabelValueOption";
  label: Scalars["String"];
  value: Scalars["String"];
};

export type LineItem = {
  __typename?: "LineItem";
  alreadyPaid: Scalars["Boolean"];
  amount: Scalars["Float"];
  currency: Scalars["String"];
  description: Scalars["String"];
  id: Scalars["ID"];
  kind: LineItemKind;
  manuallyPaid: Scalars["Boolean"];
  outboundPayment?: Maybe<OutboundPayment>;
};

export enum LineItemKind {
  AdditionalFee = "ADDITIONAL_FEE",
  BookingFee = "BOOKING_FEE",
  Expense = "EXPENSE",
  InvoiceFee = "INVOICE_FEE",
  JobPayment = "JOB_PAYMENT",
  LatePayment = "LATE_PAYMENT",
  PlatformFee = "PLATFORM_FEE",
  TransactionFee = "TRANSACTION_FEE",
}

export type LinkPaymentIntentResponse = {
  __typename?: "LinkPaymentIntentResponse";
  url: Scalars["String"];
};

export type Measurement = {
  __typename?: "Measurement";
  maximum: Scalars["Int"];
  minimum: Scalars["Int"];
};

export enum MeasurementDisplay {
  Centimeters = "CENTIMETERS",
  EuShoe = "EU_SHOE",
  FeetAndInches = "FEET_AND_INCHES",
  Inches = "INCHES",
  MetersAndCentimeters = "METERS_AND_CENTIMETERS",
  UkShoe = "UK_SHOE",
}

export enum MediaLocation {
  Asia = "ASIA",
  Emea = "EMEA",
  Europe = "EUROPE",
  Global = "GLOBAL",
  NorthAmerica = "NORTH_AMERICA",
  OnlineOnly = "ONLINE_ONLY",
  Other = "OTHER",
  SouthAmerica = "SOUTH_AMERICA",
  Uk = "UK",
}

export enum MediaType {
  AllDigitalMedia = "ALL_DIGITAL_MEDIA",
  AllPrintMedia = "ALL_PRINT_MEDIA",
  B2BSales = "B2B_SALES",
  Broadcast = "BROADCAST",
  Brochures = "BROCHURES",
  Casting = "CASTING",
  Cinema = "CINEMA",
  Collateral = "COLLATERAL",
  DigitalPosters = "DIGITAL_POSTERS",
  DirectMail = "DIRECT_MAIL",
  Editorial = "EDITORIAL",
  Exhibition = "EXHIBITION",
  Internal = "INTERNAL",
  InternationalMedia = "INTERNATIONAL_MEDIA",
  Intranet = "INTRANET",
  InStore = "IN_STORE",
  Marketing = "MARKETING",
  Ooh = "OOH",
  Other = "OTHER",
  Packaging = "PACKAGING",
  PaidSocialMedia = "PAID_SOCIAL_MEDIA",
  Portfolio = "PORTFOLIO",
  Pos = "POS",
  PressPr = "PRESS_PR",
  PrintAdvertising = "PRINT_ADVERTISING",
  RightsForThirdPartyChannels = "RIGHTS_FOR_THIRD_PARTY_CHANNELS",
  Show = "SHOW",
  SocialMedia = "SOCIAL_MEDIA",
  Tvc = "TVC",
  Website = "WEBSITE",
  Youtube = "YOUTUBE",
}

export type Message = {
  __typename?: "Message";
  chatroom: Chatroom;
  content: Scalars["String"];
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  messageAssets: Array<MessageAsset>;
  sender: User;
};

export type MessageAsset = {
  __typename?: "MessageAsset";
  height?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  mediaUrl: Scalars["String"];
  width?: Maybe<Scalars["Int"]>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: "MessageConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: "MessageEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Message;
};

export type MissingMediaCount = {
  __typename?: "MissingMediaCount";
  count: Scalars["Int"];
  desired: Scalars["Int"];
  kind: AssetKind;
};

export type Mutation = {
  __typename?: "Mutation";
  acceptTalentApplication?: Maybe<TalentApplication>;
  acceptTerms?: Maybe<TermsStatus>;
  activateBloom?: Maybe<SuccessResponse>;
  addLineItem?: Maybe<LineItem>;
  addMessageToChatroom?: Maybe<Message>;
  addSavedTalentToCollections?: Maybe<SavedTalent>;
  addTalent?: Maybe<Job>;
  agencyApproveJob?: Maybe<Job>;
  agencyRejectJob?: Maybe<Job>;
  agencyRespondOnBehalf?: Maybe<JobTalent>;
  answerAgencyQuestion?: Maybe<JobAgencyQuestion>;
  answerCounterOffer?: Maybe<JobTalent>;
  applyToOpenCall?: Maybe<JobApplication>;
  approveJob?: Maybe<Job>;
  approveOpenCall?: Maybe<OpenCall>;
  archiveAgency?: Maybe<Agency>;
  archiveJobs?: Maybe<Array<Job>>;
  askContactAboutJob?: Maybe<JobAgencyQuestion>;
  assignJob?: Maybe<Job>;
  awaitJobPayment?: Maybe<Job>;
  broadcastOpenCall?: Maybe<OpenCallBroadcastResult>;
  cancelJob?: Maybe<Job>;
  categorisePortfolioImages?: Maybe<SuccessResponse>;
  changePassword?: Maybe<User>;
  closeAgencyQuestion?: Maybe<JobAgencyQuestion>;
  closeCasting?: Maybe<Job>;
  closeOpenCall?: Maybe<OpenCall>;
  completeJob?: Maybe<Job>;
  confirmJobInvoicePayment?: Maybe<Job>;
  confirmTalent?: Maybe<Job>;
  connectInstagram?: Maybe<ConnectInstagramPayload>;
  convertPackageToDraft?: Maybe<Package>;
  convertPackageToJob?: Maybe<Package>;
  counterJobOffer?: Maybe<JobTalent>;
  createAgency?: Maybe<Agency>;
  createAgencyBookerNote?: Maybe<Note>;
  createAgencyTalent?: Maybe<User>;
  createAgencyTalentInvitation?: Maybe<TalentInvitation>;
  createAgencyTalentNote?: Maybe<Note>;
  createAgentProfile?: Maybe<User>;
  createAsset?: Maybe<Asset>;
  createBillingCompany?: Maybe<BillingCompany>;
  createBooker?: Maybe<User>;
  createBookerProfile?: Maybe<User>;
  createBookingCompanyNote?: Maybe<Note>;
  createBroadcast?: Maybe<SuccessResponse>;
  createChatroom?: Maybe<Chatroom>;
  createDeskRentalPaymentIntent?: Maybe<LinkPaymentIntentResponse>;
  createJob?: Maybe<Job>;
  createJobDispute?: Maybe<JobDispute>;
  createJobNote?: Maybe<Note>;
  createJobVertical?: Maybe<Job>;
  createMarketingAttribution?: Maybe<Scalars["Boolean"]>;
  createOpenCall?: Maybe<OpenCall>;
  createPackage?: Maybe<Package>;
  createPaymentIntent?: Maybe<PaymentIntentResponse>;
  createPortfolioImageCategory?: Maybe<PortfolioImageCategory>;
  createPortfolioImages?: Maybe<Array<PortfolioImage>>;
  createSavedTalentCollection?: Maybe<SavedTalentCollection>;
  createTalentProfile?: Maybe<User>;
  createTalentReview?: Maybe<Review>;
  createUser?: Maybe<User>;
  declineOpenCallEndorsement?: Maybe<JobApplicationVertical>;
  deleteAccount?: Maybe<Scalars["ID"]>;
  deleteAgency?: Maybe<Agency>;
  deleteAgencyBookerNote?: Maybe<Note>;
  deleteAgencyTalent?: Maybe<User>;
  deleteAgencyTalentContract?: Maybe<User>;
  deleteAgencyTalentFeaturedAsset?: Maybe<User>;
  deleteAgencyTalentNote?: Maybe<Note>;
  deleteAgencyUser?: Maybe<User>;
  deleteAgentInvitation?: Maybe<AgentInvitation>;
  deleteBillingCompany?: Maybe<DeleteBillingCompanyPayload>;
  deleteBookerInvitation?: Maybe<SuccessResponse>;
  deleteBookingCompanyBooker?: Maybe<SuccessResponse>;
  deleteBookingCompanyNote?: Maybe<Note>;
  deleteJobDeckFile?: Maybe<DeckFile>;
  deleteJobNote?: Maybe<Note>;
  deleteJobVertical?: Maybe<JobVertical>;
  deleteLineItem?: Maybe<LineItem>;
  deleteOutboundPayment?: Maybe<OutboundPayment>;
  deletePackage?: Maybe<Package>;
  deletePackageDeckFile?: Maybe<DeckFile>;
  deletePortfolioImageCategory?: Maybe<SuccessResponse>;
  deletePortfolioImages?: Maybe<SuccessResponse>;
  deleteSavedTalentCollection?: Maybe<SavedTalentCollection>;
  deleteTalentInvitation?: Maybe<SuccessResponse>;
  disconnectInstagram?: Maybe<DisconnectInstagramPayload>;
  endorseOpenCallApplication?: Maybe<JobApplicationVertical>;
  enhanceJobBrief?: Maybe<EnhanceJobBriefPayload>;
  exchangeToken?: Maybe<Scalars["String"]>;
  expireJob?: Maybe<Job>;
  /** @deprecated Invoice payments are no longer processed through trustshare */
  finalizeInvoice?: Maybe<SuccessResponse>;
  forgetTalent?: Maybe<SavedTalent>;
  generateJobInvoiceForOutstandingLineItems?: Maybe<SuccessResponse>;
  generateLatePaymentInvoice?: Maybe<SuccessResponse>;
  generatePresignedUrl?: Maybe<PresignedUrl>;
  inviteAgency?: Maybe<AgentInvitation>;
  inviteUserToAgency?: Maybe<AgentInvitation>;
  inviteUserToBookingCompany?: Maybe<BookerInvitation>;
  jobPostCompletionAction?: Maybe<Job>;
  markInvoicePaid?: Maybe<Invoice>;
  markNotificationRead?: Maybe<Notification>;
  onboardAgent?: Maybe<AgentOnboarding>;
  onboardBooker?: Maybe<User>;
  onboardTalent?: Maybe<TalentOnboarding>;
  previewAgencyTalentTransfer?: Maybe<AgencyTransferPreview>;
  previewOpenCallAudience?: Maybe<OpenCallAudiencePreview>;
  progressOpenCallApplication?: Maybe<JobApplication>;
  publishAgencyBrief?: Maybe<Job>;
  publishOpenCall?: Maybe<OpenCall>;
  publishPackage?: Maybe<Package>;
  readMessagesInChatroom?: Maybe<SuccessResponse>;
  rebuildInvoice?: Maybe<Invoice>;
  refreshOpenCallPublicCopy?: Maybe<OpenCall>;
  registerOpenCallApplicant?: Maybe<User>;
  registerPushToken?: Maybe<Scalars["String"]>;
  reissueInvoice?: Maybe<Invoice>;
  rejectJob?: Maybe<Job>;
  rejectOpenCallApplication?: Maybe<JobApplication>;
  rejectTalentApplication?: Maybe<TalentApplication>;
  removeJobAssignee?: Maybe<Job>;
  removePortfolioImageCategorisation?: Maybe<PortfolioImageCategory>;
  removeSavedTalentFromCollections?: Maybe<SavedTalent>;
  removeTalent?: Maybe<Job>;
  replacePackageTalent?: Maybe<Package>;
  replaceTalent?: Maybe<Job>;
  requestBankAccountChange?: Maybe<BankAccountChangeChallenge>;
  requestMoreInfo?: Maybe<Job>;
  requestToken?: Maybe<Scalars["String"]>;
  resendOnboardEmail?: Maybe<User>;
  resetGroupToDefault?: Maybe<User>;
  resetInvoicePaymentMethod?: Maybe<Invoice>;
  resolveJobDispute?: Maybe<JobDispute>;
  restoreAgency?: Maybe<Agency>;
  resubmitJob?: Maybe<Job>;
  retrieveTokenExpiry?: Maybe<Scalars["ISO8601DateTime"]>;
  reviewOpenCallApplication?: Maybe<JobApplication>;
  saveAgencyBrief?: Maybe<Job>;
  saveTalent?: Maybe<SavedTalent>;
  sendEmailTest?: Maybe<SendEmailTestPayload>;
  sendPaymentVerificationEmail?: Maybe<User>;
  sendTalentNudge?: Maybe<Job>;
  setAgentCurator?: Maybe<User>;
  setDefaultBillingCompany?: Maybe<BillingCompany>;
  setInvoiceBillingCompany?: Maybe<Invoice>;
  setInvoiceFee?: Maybe<Invoice>;
  setJobTalentFee?: Maybe<JobTalent>;
  shortlistOpenCallApplication?: Maybe<JobApplication>;
  sortPortfolioImages?: Maybe<Array<PortfolioImage>>;
  submitOpenCall?: Maybe<OpenCall>;
  subscribeToNewsletter?: Maybe<Scalars["Boolean"]>;
  suspendOpenCallApplication?: Maybe<JobApplication>;
  talentAcceptJob?: Maybe<Job>;
  talentJobResponse?: Maybe<Job>;
  talentRejectJob?: Maybe<Job>;
  transferAgencyTalent?: Maybe<AgencyRosterTransfer>;
  unarchiveJobs?: Maybe<Array<Job>>;
  updateAgency?: Maybe<Agency>;
  updateAgencyTalent?: Maybe<User>;
  updateAgencyVisibility?: Maybe<Agency>;
  updateBankAccount?: Maybe<BankAccount>;
  updateBillingCompany?: Maybe<BillingCompany>;
  updateBookingCompany?: Maybe<BookingCompany>;
  updateCastingRequestStatus?: Maybe<CastingRequest>;
  updateChatroomHelp?: Maybe<Chatroom>;
  updateInvoice?: Maybe<Invoice>;
  updateJob?: Maybe<Job>;
  updateJobAgencies?: Maybe<Array<JobAgency>>;
  updateJobTalents?: Maybe<Array<JobTalent>>;
  updateJobVerticals?: Maybe<Job>;
  updateLineItem?: Maybe<LineItem>;
  updateOpenCall?: Maybe<OpenCall>;
  updateOwnUser?: Maybe<User>;
  updatePackage?: Maybe<Package>;
  updatePortfolioImageCategory?: Maybe<PortfolioImageCategory>;
  updatePortfolioImagesCategorisation?: Maybe<PortfolioImageCategory>;
  updateReview?: Maybe<Review>;
  updateSavedTalentCollection?: Maybe<SavedTalentCollection>;
  updateSavedTalentCollections?: Maybe<BookerProfile>;
  updateUser?: Maybe<User>;
  upsertCastingRequests?: Maybe<Array<CastingRequest>>;
  upsertTalentProfileCache?: Maybe<UpsertTalentProfileCachePayload>;
  verifyPackageBooker?: Maybe<Package>;
  voidInvoice?: Maybe<SuccessResponse>;
  withdrawAgencyBrief?: Maybe<Job>;
  withdrawOpenCallApplication?: Maybe<JobApplication>;
};

export type MutationAcceptTalentApplicationArgs = {
  id: Scalars["ID"];
};

export type MutationAcceptTermsArgs = {
  accepted: Scalars["Boolean"];
  documentSha256: Scalars["String"];
  version: Scalars["String"];
};

export type MutationActivateBloomArgs = {
  jobId: Scalars["ID"];
};

export type MutationAddLineItemArgs = {
  amount: Scalars["Float"];
  currency: Scalars["String"];
  description: Scalars["String"];
  jobTalentId: Scalars["ID"];
  kind: LineItemKind;
  manuallyPaid: Scalars["Boolean"];
};

export type MutationAddMessageToChatroomArgs = {
  chatroomId: Scalars["ID"];
  content: Scalars["String"];
  messageAssets?: InputMaybe<Array<FileUploadInput>>;
};

export type MutationAddSavedTalentToCollectionsArgs = {
  collectionIds: Array<Scalars["ID"]>;
  talentId: Scalars["ID"];
};

export type MutationAddTalentArgs = {
  jobId: Scalars["ID"];
  talentIds: Array<Scalars["ID"]>;
};

export type MutationAgencyApproveJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationAgencyRejectJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationAgencyRespondOnBehalfArgs = {
  expectedFee?: InputMaybe<Scalars["Float"]>;
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
  rejectionNote?: InputMaybe<Scalars["String"]>;
  rejectionReason?: InputMaybe<JobTalentRejectionReason>;
  response: JobTalentStateEvent;
};

export type MutationAnswerAgencyQuestionArgs = {
  answer: Scalars["String"];
  questionId: Scalars["ID"];
};

export type MutationAnswerCounterOfferArgs = {
  amount?: InputMaybe<Scalars["Float"]>;
  counterOfferId: Scalars["ID"];
  decision: CounterOfferDecision;
  jobId: Scalars["ID"];
};

export type MutationApplyToOpenCallArgs = {
  acquisitionSource?: InputMaybe<Scalars["String"]>;
  adultAttested?: InputMaybe<Scalars["Boolean"]>;
  answers?: InputMaybe<Scalars["JSON"]>;
  assetIds?: InputMaybe<Array<Scalars["ID"]>>;
  dateOfBirth?: InputMaybe<Scalars["ISO8601Date"]>;
  jobVerticalIds: Array<Scalars["ID"]>;
  note?: InputMaybe<Scalars["String"]>;
  openCallId?: InputMaybe<Scalars["ID"]>;
  openCallSlug?: InputMaybe<Scalars["String"]>;
  referralSource?: InputMaybe<Scalars["String"]>;
  turnstileToken?: InputMaybe<Scalars["String"]>;
};

export type MutationApproveJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationApproveOpenCallArgs = {
  openCallId: Scalars["ID"];
};

export type MutationArchiveAgencyArgs = {
  id: Scalars["ID"];
};

export type MutationArchiveJobsArgs = {
  jobIds: Array<Scalars["ID"]>;
};

export type MutationAskContactAboutJobArgs = {
  jobId: Scalars["ID"];
  question: Scalars["String"];
};

export type MutationAssignJobArgs = {
  assigneeId: Scalars["ID"];
  jobId: Scalars["ID"];
};

export type MutationAwaitJobPaymentArgs = {
  jobId: Scalars["ID"];
  talentIdsToConfirm: Array<Scalars["ID"]>;
};

export type MutationBroadcastOpenCallArgs = {
  audienceFingerprint: Scalars["String"];
  dryRun?: InputMaybe<Scalars["Boolean"]>;
  openCallId: Scalars["ID"];
  recipientLimit?: InputMaybe<Scalars["Int"]>;
};

export type MutationCancelJobArgs = {
  cancellationNote?: InputMaybe<Scalars["String"]>;
  cancellationReason: JobCancellationReason;
  jobId: Scalars["ID"];
};

export type MutationCategorisePortfolioImagesArgs = {
  portfolioImageCategoryIds: Array<Scalars["ID"]>;
  portfolioImageIds: Array<Scalars["ID"]>;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars["String"];
  newPassword: Scalars["String"];
};

export type MutationCloseAgencyQuestionArgs = {
  questionId: Scalars["ID"];
};

export type MutationCloseCastingArgs = {
  jobId: Scalars["ID"];
  unresolvedJobTalentIds: Array<Scalars["ID"]>;
};

export type MutationCloseOpenCallArgs = {
  closeReason?: InputMaybe<Scalars["String"]>;
  openCallId: Scalars["ID"];
};

export type MutationCompleteJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationConfirmJobInvoicePaymentArgs = {
  jobId: Scalars["ID"];
};

export type MutationConfirmTalentArgs = {
  acceptedTerms: Scalars["Boolean"];
  jobId: Scalars["ID"];
  jobTalentIds: Array<Scalars["ID"]>;
};

export type MutationConnectInstagramArgs = {
  code: Scalars["String"];
  state: Scalars["String"];
  talentId?: InputMaybe<Scalars["ID"]>;
};

export type MutationConvertPackageToDraftArgs = {
  packageId: Scalars["ID"];
};

export type MutationConvertPackageToJobArgs = {
  allTravelFeesCovered?: InputMaybe<Scalars["Boolean"]>;
  jobId?: InputMaybe<Scalars["ID"]>;
  nudityType?: InputMaybe<NudityInvolvement>;
  packageId: Scalars["ID"];
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
};

export type MutationCounterJobOfferArgs = {
  amount: Scalars["Float"];
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateAgencyArgs = {
  location: Scalars["String"];
  logo?: InputMaybe<FileUploadInput>;
  name: Scalars["String"];
  paymentsEmail?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateAgencyBookerNoteArgs = {
  body: Scalars["String"];
  bookerId: Scalars["ID"];
};

export type MutationCreateAgencyTalentArgs = {
  addressLine1: Scalars["String"];
  addressLine2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  county?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  postcode: Scalars["String"];
  talentInvitationToken?: InputMaybe<Scalars["String"]>;
  talentProfile: CreateTalentProfileInput;
};

export type MutationCreateAgencyTalentInvitationArgs = {
  email: Scalars["String"];
  published?: InputMaybe<Scalars["Boolean"]>;
  vertical: TalentVertical;
};

export type MutationCreateAgencyTalentNoteArgs = {
  body: Scalars["String"];
  talentId: Scalars["ID"];
};

export type MutationCreateAgentProfileArgs = {
  agency: CreateAgencyInput;
  role: AgentProfileRole;
};

export type MutationCreateAssetArgs = {
  assetableId?: InputMaybe<Scalars["ID"]>;
  assetableType?: InputMaybe<Scalars["String"]>;
  file: FileUploadInput;
  kind: Scalars["String"];
  openCallId?: InputMaybe<Scalars["ID"]>;
  openCallSlug?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateBillingCompanyArgs = {
  accountName: Scalars["String"];
  accountNumber: Scalars["String"];
  bankName: Scalars["String"];
  companyName: Scalars["String"];
  invoicePrefix: Scalars["String"];
  name: Scalars["String"];
  officeAddress: Scalars["String"];
  sortCode: Scalars["String"];
  vatNumber?: InputMaybe<Scalars["String"]>;
  vatRegistered?: InputMaybe<Scalars["Boolean"]>;
  website: Scalars["String"];
};

export type MutationCreateBookerArgs = {
  company: Scalars["String"];
  email: Scalars["String"];
  firstName?: InputMaybe<Scalars["String"]>;
  headcountEstimate?: InputMaybe<CompanyHeadcountEstimate>;
  kind?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  phoneNumber: Scalars["String"];
  role?: InputMaybe<Scalars["String"]>;
  surfacedFrom?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateBookerProfileArgs = {
  company: Scalars["String"];
  headcountEstimate?: InputMaybe<CompanyHeadcountEstimate>;
  role?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type MutationCreateBookingCompanyNoteArgs = {
  body: Scalars["String"];
  bookingCompanyId: Scalars["ID"];
};

export type MutationCreateBroadcastArgs = {
  jobId: Scalars["ID"];
  message: Scalars["String"];
  messageAssets?: InputMaybe<Array<FileUploadInput>>;
  name?: InputMaybe<Scalars["String"]>;
  userSlugs: Array<Scalars["String"]>;
};

export type MutationCreateChatroomArgs = {
  jobId: Scalars["ID"];
  message?: InputMaybe<Scalars["String"]>;
  messageAssets?: InputMaybe<Array<FileUploadInput>>;
  name?: InputMaybe<Scalars["String"]>;
  userSlugs: Array<Scalars["String"]>;
};

export type MutationCreateDeskRentalPaymentIntentArgs = {
  email: Scalars["String"];
  invoiceNumber: Scalars["String"];
};

export type MutationCreateJobArgs = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  affiliate?: InputMaybe<Scalars["String"]>;
  allTravelFeesCovered?: InputMaybe<Scalars["Boolean"]>;
  brand: Scalars["String"];
  cateringProvided?: InputMaybe<Scalars["Boolean"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description: Scalars["String"];
  endDate: Scalars["ISO8601Date"];
  headcountEstimate?: InputMaybe<HeadcountEstimate>;
  jobVerticals?: InputMaybe<Array<CreateJobVerticalInput>>;
  kind: JobKind;
  location?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  nudityType?: InputMaybe<NudityInvolvement>;
  selfTapeRequired?: InputMaybe<Scalars["Boolean"]>;
  startDate: Scalars["ISO8601Date"];
  talentIds: Array<Scalars["ID"]>;
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
  usage: Scalars["String"];
  usages?: InputMaybe<Array<UsageInput>>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreateJobDisputeArgs = {
  jobId: Scalars["ID"];
  reportedBy?: InputMaybe<Scalars["ID"]>;
};

export type MutationCreateJobNoteArgs = {
  body: Scalars["String"];
  jobId: Scalars["ID"];
};

export type MutationCreateJobVerticalArgs = {
  jobId: Scalars["ID"];
  jobVertical: CreateJobVerticalInput;
};

export type MutationCreateMarketingAttributionArgs = {
  eventName: Scalars["String"];
  jobId?: InputMaybe<Scalars["Int"]>;
  utmData: UtmDataInput;
};

export type MutationCreateOpenCallArgs = {
  applicantCap?: InputMaybe<Scalars["Int"]>;
  applicationAccess?: InputMaybe<Scalars["String"]>;
  applicationDeadline?: InputMaybe<Scalars["ISO8601DateTime"]>;
  bookingCompanyId?: InputMaybe<Scalars["ID"]>;
  brand?: InputMaybe<Scalars["String"]>;
  brief?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  crewSize?: InputMaybe<HeadcountEstimate>;
  dateMode?: InputMaybe<Scalars["String"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  expensesCovered?: InputMaybe<Scalars["Boolean"]>;
  heroAssetId?: InputMaybe<Scalars["ID"]>;
  jobVerticals?: InputMaybe<Array<CreateJobVerticalInput>>;
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  logoAssetId?: InputMaybe<Scalars["ID"]>;
  questions?: InputMaybe<Array<OpenCallQuestionInput>>;
  requirements?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  title?: InputMaybe<Scalars["String"]>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
  visibility?: InputMaybe<Scalars["String"]>;
};

export type MutationCreatePackageArgs = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  allTravelFeesCovered?: InputMaybe<Scalars["Boolean"]>;
  bookerCompany: Scalars["String"];
  bookerEmail: Scalars["String"];
  bookerName: Scalars["String"];
  bookerPhoneNumber?: InputMaybe<Scalars["String"]>;
  brand?: InputMaybe<Scalars["String"]>;
  cateringProvided?: InputMaybe<Scalars["Boolean"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  headcountEstimate?: InputMaybe<HeadcountEstimate>;
  isTemplate?: InputMaybe<Scalars["Boolean"]>;
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  nudityType?: InputMaybe<NudityInvolvement>;
  packageVerticals?: InputMaybe<Array<CreatePackageVerticalInput>>;
  selfTapeRequired?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  talentIds?: InputMaybe<Array<Scalars["ID"]>>;
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
  usage?: InputMaybe<Scalars["String"]>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationCreatePaymentIntentArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationCreatePortfolioImageCategoryArgs = {
  name: Scalars["String"];
  talentProfileId: Scalars["ID"];
};

export type MutationCreatePortfolioImagesArgs = {
  files: Array<FileUploadInput>;
  portfolioImageCategoryId?: InputMaybe<Scalars["ID"]>;
  talentProfileId: Scalars["ID"];
};

export type MutationCreateSavedTalentCollectionArgs = {
  name: Scalars["String"];
};

export type MutationCreateTalentProfileArgs = {
  additionalLocations?: InputMaybe<Array<TalentLocationInput>>;
  agencyId?: InputMaybe<Scalars["ID"]>;
  biography?: InputMaybe<Scalars["String"]>;
  contract?: InputMaybe<FileUploadInput>;
  dateOfBirth: Scalars["ISO8601Date"];
  dietaryRequirements?: InputMaybe<Array<Scalars["String"]>>;
  gender: Gender;
  hobbies?: InputMaybe<Array<Scalars["String"]>>;
  instagramUsername?: InputMaybe<Scalars["String"]>;
  isContactLaunch?: InputMaybe<Scalars["Boolean"]>;
  minDayRate?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  onboarded?: InputMaybe<Scalars["Boolean"]>;
  pastClients?: InputMaybe<Array<Scalars["String"]>>;
  portfolioImages?: InputMaybe<Array<PortfolioImageInput>>;
  primaryLocation: TalentLocationInput;
  pronouns?: InputMaybe<Pronouns>;
  published?: InputMaybe<Scalars["Boolean"]>;
  shrineAssets?: InputMaybe<Array<AssetFileUploadInput>>;
  socialMediaFields?: InputMaybe<Array<SocialMediaInput>>;
  vertical: TalentVertical;
  verticalData?: InputMaybe<Scalars["JSON"]>;
  website?: InputMaybe<Scalars["String"]>;
  yearsExperience?: InputMaybe<Scalars["Int"]>;
};

export type MutationCreateTalentReviewArgs = {
  createdAt?: InputMaybe<Scalars["ISO8601Date"]>;
  jobId: Scalars["ID"];
  rating: Scalars["Int"];
  reviewerId: Scalars["ID"];
  talentId: Scalars["ID"];
};

export type MutationCreateUserArgs = {
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  county?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  postcode?: InputMaybe<Scalars["String"]>;
  registeringAs: UserKind;
  ssoVerified?: InputMaybe<Scalars["Boolean"]>;
  surfacedFrom?: InputMaybe<Scalars["String"]>;
};

export type MutationDeclineOpenCallEndorsementArgs = {
  applicationRoleId: Scalars["ID"];
  reason: Scalars["String"];
};

export type MutationDeleteAgencyArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteAgencyBookerNoteArgs = {
  bookerId: Scalars["ID"];
  noteId: Scalars["ID"];
};

export type MutationDeleteAgencyTalentArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteAgencyTalentContractArgs = {
  talentId: Scalars["ID"];
};

export type MutationDeleteAgencyTalentFeaturedAssetArgs = {
  talentId: Scalars["ID"];
};

export type MutationDeleteAgencyTalentNoteArgs = {
  noteId: Scalars["ID"];
  talentId: Scalars["ID"];
};

export type MutationDeleteAgencyUserArgs = {
  agencyId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
};

export type MutationDeleteAgentInvitationArgs = {
  agencyId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
};

export type MutationDeleteBillingCompanyArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteBookerInvitationArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteBookingCompanyBookerArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteBookingCompanyNoteArgs = {
  bookingCompanyId: Scalars["ID"];
  noteId: Scalars["ID"];
};

export type MutationDeleteJobDeckFileArgs = {
  deckFileId: Scalars["ID"];
  jobId: Scalars["ID"];
};

export type MutationDeleteJobNoteArgs = {
  jobId: Scalars["ID"];
  noteId: Scalars["ID"];
};

export type MutationDeleteJobVerticalArgs = {
  jobVerticalId: Scalars["ID"];
};

export type MutationDeleteLineItemArgs = {
  jobTalentId: Scalars["ID"];
  lineItemId: Scalars["ID"];
};

export type MutationDeleteOutboundPaymentArgs = {
  outboundPaymentId: Scalars["ID"];
};

export type MutationDeletePackageArgs = {
  packageId: Scalars["ID"];
};

export type MutationDeletePackageDeckFileArgs = {
  deckFileId: Scalars["ID"];
  packageId: Scalars["ID"];
};

export type MutationDeletePortfolioImageCategoryArgs = {
  portfolioImageCategoryId: Scalars["ID"];
};

export type MutationDeletePortfolioImagesArgs = {
  portfolioImageIds: Array<Scalars["ID"]>;
};

export type MutationDeleteSavedTalentCollectionArgs = {
  id: Scalars["ID"];
};

export type MutationDeleteTalentInvitationArgs = {
  id: Scalars["ID"];
};

export type MutationDisconnectInstagramArgs = {
  talentId?: InputMaybe<Scalars["ID"]>;
};

export type MutationEndorseOpenCallApplicationArgs = {
  applicationRoleId: Scalars["ID"];
};

export type MutationEnhanceJobBriefArgs = {
  rawDescription: Scalars["String"];
  usage?: InputMaybe<Scalars["String"]>;
  vertical?: InputMaybe<TalentVertical>;
};

export type MutationExchangeTokenArgs = {
  newPassword: Scalars["String"];
  token: Scalars["String"];
};

export type MutationExpireJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationFinalizeInvoiceArgs = {
  invoiceId: Scalars["ID"];
  trustshareCheckoutId: Scalars["String"];
  trustshareInvoiceId: Scalars["String"];
};

export type MutationForgetTalentArgs = {
  talentId: Scalars["ID"];
};

export type MutationGenerateJobInvoiceForOutstandingLineItemsArgs = {
  jobId: Scalars["ID"];
};

export type MutationGenerateLatePaymentInvoiceArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationGeneratePresignedUrlArgs = {
  attachment: Scalars["String"];
  byteSize: Scalars["Int"];
  checksum: Scalars["String"];
  contentType: Scalars["String"];
  filename?: InputMaybe<Scalars["String"]>;
};

export type MutationInviteAgencyArgs = {
  email: Scalars["String"];
  hideAgencyTalent?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationInviteUserToAgencyArgs = {
  agencyId?: InputMaybe<Scalars["ID"]>;
  email: Scalars["String"];
};

export type MutationInviteUserToBookingCompanyArgs = {
  email: Scalars["String"];
};

export type MutationJobPostCompletionActionArgs = {
  action: JobPostCompletionAction;
  completed: Scalars["Boolean"];
  jobId: Scalars["ID"];
};

export type MutationMarkInvoicePaidArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationMarkNotificationReadArgs = {
  id: Scalars["ID"];
};

export type MutationOnboardAgentArgs = {
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  phoneNumber: Scalars["String"];
  token: Scalars["String"];
};

export type MutationOnboardBookerArgs = {
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  token: Scalars["String"];
};

export type MutationOnboardTalentArgs = {
  bankAccountAccountNumber?: InputMaybe<Scalars["String"]>;
  bankAccountIban?: InputMaybe<Scalars["String"]>;
  bankAccountKind?: InputMaybe<BankAccountKind>;
  bankAccountOwnerName?: InputMaybe<Scalars["String"]>;
  bankAccountSortCode?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  token: Scalars["String"];
};

export type MutationPreviewAgencyTalentTransferArgs = {
  destinationAgencyId: Scalars["ID"];
  sourceAgencyId: Scalars["ID"];
  talentProfileIds: Array<Scalars["ID"]>;
};

export type MutationPreviewOpenCallAudienceArgs = {
  openCallId: Scalars["ID"];
};

export type MutationProgressOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
  jobVerticalId: Scalars["ID"];
};

export type MutationPublishAgencyBriefArgs = {
  expectedBrief: AgencyBriefInput;
  expectedSourceFingerprint: Scalars["String"];
  expectedState: Scalars["String"];
  jobId: Scalars["ID"];
};

export type MutationPublishOpenCallArgs = {
  openCallId: Scalars["ID"];
};

export type MutationPublishPackageArgs = {
  packageId: Scalars["ID"];
};

export type MutationReadMessagesInChatroomArgs = {
  chatroomId: Scalars["ID"];
};

export type MutationRebuildInvoiceArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationRefreshOpenCallPublicCopyArgs = {
  openCallId: Scalars["ID"];
};

export type MutationRegisterOpenCallApplicantArgs = {
  addressLine1: Scalars["String"];
  assetIds?: InputMaybe<Array<Scalars["ID"]>>;
  biography?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  dateOfBirth: Scalars["ISO8601Date"];
  email: Scalars["String"];
  gender: Gender;
  hobbies?: InputMaybe<Array<Scalars["String"]>>;
  name: Scalars["String"];
  openCallId?: InputMaybe<Scalars["ID"]>;
  openCallSlug?: InputMaybe<Scalars["String"]>;
  password: Scalars["String"];
  phoneNumber?: InputMaybe<Scalars["String"]>;
  postcode: Scalars["String"];
  primaryLocation: TalentLocationInput;
  pronouns?: InputMaybe<Pronouns>;
  turnstileToken?: InputMaybe<Scalars["String"]>;
  vertical: TalentVertical;
  verticalData?: InputMaybe<Scalars["JSON"]>;
};

export type MutationRegisterPushTokenArgs = {
  token: Scalars["String"];
};

export type MutationReissueInvoiceArgs = {
  billingCompanyId: Scalars["ID"];
  expectedInvoiceNumber?: InputMaybe<Scalars["String"]>;
  invoiceId: Scalars["ID"];
  notifyClient: Scalars["Boolean"];
};

export type MutationRejectJobArgs = {
  jobId: Scalars["ID"];
  rejectionNote?: InputMaybe<Scalars["String"]>;
  rejectionReason: JobRejectionReason;
};

export type MutationRejectOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
  reason: Scalars["String"];
};

export type MutationRejectTalentApplicationArgs = {
  id: Scalars["ID"];
};

export type MutationRemoveJobAssigneeArgs = {
  jobId: Scalars["ID"];
};

export type MutationRemovePortfolioImageCategorisationArgs = {
  portfolioImageCategoryId: Scalars["ID"];
  portfolioImageId: Scalars["ID"];
};

export type MutationRemoveSavedTalentFromCollectionsArgs = {
  collectionIds: Array<Scalars["ID"]>;
  talentId: Scalars["ID"];
};

export type MutationRemoveTalentArgs = {
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
};

export type MutationReplacePackageTalentArgs = {
  packageId: Scalars["ID"];
  talentIds: Array<Scalars["ID"]>;
};

export type MutationReplaceTalentArgs = {
  jobId: Scalars["ID"];
  talentIds: Array<Scalars["ID"]>;
};

export type MutationRequestBankAccountChangeArgs = {
  accountNumber?: InputMaybe<Scalars["String"]>;
  iban?: InputMaybe<Scalars["String"]>;
  kind: BankAccountKind;
  ownerName: Scalars["String"];
  sortCode?: InputMaybe<Scalars["String"]>;
  verificationSession: Scalars["String"];
};

export type MutationRequestMoreInfoArgs = {
  jobId: Scalars["ID"];
  text: Scalars["String"];
};

export type MutationRequestTokenArgs = {
  email: Scalars["String"];
};

export type MutationResendOnboardEmailArgs = {
  userId: Scalars["ID"];
};

export type MutationResetGroupToDefaultArgs = {
  talentId: Scalars["ID"];
};

export type MutationResetInvoicePaymentMethodArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationResolveJobDisputeArgs = {
  id: Scalars["ID"];
};

export type MutationRestoreAgencyArgs = {
  id: Scalars["ID"];
};

export type MutationResubmitJobArgs = {
  jobDetails?: InputMaybe<UpdateJobDetailsInput>;
  jobId: Scalars["ID"];
  jobVerticals?: InputMaybe<Array<UpdateJobVerticalInput>>;
  talentIds?: InputMaybe<Array<Scalars["ID"]>>;
};

export type MutationRetrieveTokenExpiryArgs = {
  token: Scalars["String"];
};

export type MutationReviewOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
};

export type MutationSaveAgencyBriefArgs = {
  apply?: InputMaybe<Scalars["Boolean"]>;
  brief: AgencyBriefInput;
  expectedBrief?: InputMaybe<AgencyBriefInput>;
  expectedSourceFingerprint?: InputMaybe<Scalars["String"]>;
  expectedState?: InputMaybe<Scalars["String"]>;
  jobId: Scalars["ID"];
  reset?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationSaveTalentArgs = {
  talentId: Scalars["ID"];
};

export type MutationSendEmailTestArgs = {
  draft?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  variant?: InputMaybe<Scalars["String"]>;
};

export type MutationSendPaymentVerificationEmailArgs = {
  userId: Scalars["ID"];
};

export type MutationSendTalentNudgeArgs = {
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
};

export type MutationSetAgentCuratorArgs = {
  agentId: Scalars["ID"];
  isCurator: Scalars["Boolean"];
};

export type MutationSetDefaultBillingCompanyArgs = {
  id: Scalars["ID"];
};

export type MutationSetInvoiceBillingCompanyArgs = {
  billingCompanyId: Scalars["ID"];
  invoiceId: Scalars["ID"];
};

export type MutationSetInvoiceFeeArgs = {
  amount: Scalars["Float"];
  feeKind: FeeKind;
  invoiceId: Scalars["ID"];
};

export type MutationSetJobTalentFeeArgs = {
  amount: Scalars["Float"];
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
};

export type MutationShortlistOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
  jobVerticalId: Scalars["ID"];
};

export type MutationSortPortfolioImagesArgs = {
  portfolioImageCategoryId?: InputMaybe<Scalars["ID"]>;
  sortOrder: Array<UpdateSortOrderInput>;
  talentProfileId?: InputMaybe<Scalars["ID"]>;
};

export type MutationSubmitOpenCallArgs = {
  openCallId: Scalars["ID"];
};

export type MutationSubscribeToNewsletterArgs = {
  email: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  source: Scalars["String"];
};

export type MutationSuspendOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
  reason: Scalars["String"];
};

export type MutationTalentAcceptJobArgs = {
  expectedFee?: InputMaybe<Scalars["Float"]>;
  jobId: Scalars["ID"];
};

export type MutationTalentJobResponseArgs = {
  expectedFee?: InputMaybe<Scalars["Float"]>;
  jobId: Scalars["ID"];
  jobTalentId: Scalars["ID"];
  rejectionNote?: InputMaybe<Scalars["String"]>;
  rejectionReason?: InputMaybe<JobTalentRejectionReason>;
  response: JobTalentStateEvent;
};

export type MutationTalentRejectJobArgs = {
  jobId: Scalars["ID"];
  rejectionNote?: InputMaybe<Scalars["String"]>;
  rejectionReason?: InputMaybe<JobTalentRejectionReason>;
};

export type MutationTransferAgencyTalentArgs = {
  agreementEvidence: Array<AgencyTransferAgreementInput>;
  destinationAgencyId: Scalars["ID"];
  previewVersion: Scalars["String"];
  requestKey: Scalars["String"];
  sourceAgencyId: Scalars["ID"];
  talentProfileIds: Array<Scalars["ID"]>;
};

export type MutationUnarchiveJobsArgs = {
  jobIds: Array<Scalars["ID"]>;
};

export type MutationUpdateAgencyArgs = {
  agencyId?: InputMaybe<Scalars["ID"]>;
  bio?: InputMaybe<Scalars["String"]>;
  commissionPercentage?: InputMaybe<Scalars["Int"]>;
  coverPhoto?: InputMaybe<FileUploadInput>;
  hideTalent?: InputMaybe<Scalars["Boolean"]>;
  instagramUsername?: InputMaybe<Scalars["String"]>;
  isPrivate?: InputMaybe<Scalars["Boolean"]>;
  location?: InputMaybe<Scalars["String"]>;
  logo?: InputMaybe<FileUploadInput>;
  name?: InputMaybe<Scalars["String"]>;
  pastClients?: InputMaybe<Array<Scalars["String"]>>;
  paymentsEmail?: InputMaybe<Scalars["String"]>;
  specialities?: InputMaybe<Array<Scalars["String"]>>;
  tiktokUsername?: InputMaybe<Scalars["String"]>;
  twitterUsername?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateAgencyTalentArgs = {
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  county?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  groupIds?: InputMaybe<Array<Scalars["ID"]>>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  postcode?: InputMaybe<Scalars["String"]>;
  talentId: Scalars["ID"];
  talentProfile?: InputMaybe<UpdateTalentProfileInput>;
};

export type MutationUpdateAgencyVisibilityArgs = {
  hideTalent: Scalars["Boolean"];
  id: Scalars["ID"];
  isPrivate: Scalars["Boolean"];
};

export type MutationUpdateBankAccountArgs = {
  accountNumber?: InputMaybe<Scalars["String"]>;
  challengeId?: InputMaybe<Scalars["ID"]>;
  iban?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<BankAccountKind>;
  ownerName?: InputMaybe<Scalars["String"]>;
  sortCode?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  verificationCode?: InputMaybe<Scalars["String"]>;
  verificationSession?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateBillingCompanyArgs = {
  accountName?: InputMaybe<Scalars["String"]>;
  accountNumber?: InputMaybe<Scalars["String"]>;
  bankName?: InputMaybe<Scalars["String"]>;
  companyName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  invoicePrefix?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  officeAddress?: InputMaybe<Scalars["String"]>;
  sortCode?: InputMaybe<Scalars["String"]>;
  vatNumber?: InputMaybe<Scalars["String"]>;
  vatRegistered?: InputMaybe<Scalars["Boolean"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateBookingCompanyArgs = {
  billingContact?: InputMaybe<Scalars["String"]>;
  billingDetailsPresent?: InputMaybe<Scalars["Boolean"]>;
  companyEmailAddress?: InputMaybe<Scalars["String"]>;
  companyRegistrationNumber?: InputMaybe<Scalars["String"]>;
  freelancer?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  registeredAddress?: InputMaybe<AddressInput>;
  tradingAddress?: InputMaybe<AddressInput>;
};

export type MutationUpdateCastingRequestStatusArgs = {
  action: Scalars["String"];
  castingRequestId: Scalars["ID"];
  note?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateChatroomHelpArgs = {
  action: Scalars["String"];
  chatroomId: Scalars["ID"];
};

export type MutationUpdateInvoiceArgs = {
  invoiceId: Scalars["ID"];
  paymentMethod?: InputMaybe<PaymentMethod>;
  poNumber?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateJobArgs = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  affiliate?: InputMaybe<Scalars["String"]>;
  allTravelFeesCovered?: InputMaybe<Scalars["Boolean"]>;
  brand?: InputMaybe<Scalars["String"]>;
  cateringProvided?: InputMaybe<Scalars["Boolean"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  excludeVat?: InputMaybe<Scalars["Boolean"]>;
  headcountEstimate?: InputMaybe<HeadcountEstimate>;
  invoiceBillingAddress?: InputMaybe<Scalars["String"]>;
  invoiceBillingName?: InputMaybe<Scalars["String"]>;
  jobId: Scalars["ID"];
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nudityType?: InputMaybe<NudityInvolvement>;
  postcode?: InputMaybe<Scalars["String"]>;
  removeTalentIds?: InputMaybe<Array<Scalars["ID"]>>;
  selfTapeRequired?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
  usage?: InputMaybe<Scalars["String"]>;
  usages?: InputMaybe<Array<UsageInput>>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateJobAgenciesArgs = {
  collections: Array<JobAgencyInput>;
};

export type MutationUpdateJobTalentsArgs = {
  collections: Array<JobTalentInput>;
};

export type MutationUpdateJobVerticalsArgs = {
  jobId: Scalars["ID"];
  jobVerticals: Array<UpdateJobVerticalInput>;
};

export type MutationUpdateLineItemArgs = {
  amount?: InputMaybe<Scalars["Float"]>;
  currency?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<LineItemKind>;
  lineItemId: Scalars["ID"];
  manuallyPaid?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdateOpenCallArgs = {
  applicantCap?: InputMaybe<Scalars["Int"]>;
  applicationAccess?: InputMaybe<Scalars["String"]>;
  applicationDeadline?: InputMaybe<Scalars["ISO8601DateTime"]>;
  bookingCompanyId?: InputMaybe<Scalars["ID"]>;
  brand?: InputMaybe<Scalars["String"]>;
  brief?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  crewSize?: InputMaybe<HeadcountEstimate>;
  dateMode?: InputMaybe<Scalars["String"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  expensesCovered?: InputMaybe<Scalars["Boolean"]>;
  heroAssetId?: InputMaybe<Scalars["ID"]>;
  jobVerticals?: InputMaybe<Array<CreateJobVerticalInput>>;
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  logoAssetId?: InputMaybe<Scalars["ID"]>;
  openCallId: Scalars["ID"];
  questions?: InputMaybe<Array<OpenCallQuestionInput>>;
  requirements?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  title?: InputMaybe<Scalars["String"]>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
  visibility?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateOwnUserArgs = {
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  bookerProfile?: InputMaybe<UpdateOwnBookerProfileInput>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  county?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  featuredAsset?: InputMaybe<FileUploadInput>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  postcode?: InputMaybe<Scalars["String"]>;
  seenOnboardingScreen?: InputMaybe<Scalars["Boolean"]>;
  talentProfile?: InputMaybe<UpdateOwnTalentProfileInput>;
};

export type MutationUpdatePackageArgs = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  bookerCompany?: InputMaybe<Scalars["String"]>;
  bookerEmail?: InputMaybe<Scalars["String"]>;
  bookerName?: InputMaybe<Scalars["String"]>;
  brand?: InputMaybe<Scalars["String"]>;
  budget?: InputMaybe<Scalars["Float"]>;
  cateringProvided?: InputMaybe<Scalars["Boolean"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  county?: InputMaybe<Scalars["String"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  expectedBookerEmail?: InputMaybe<Scalars["String"]>;
  headcountEstimate?: InputMaybe<HeadcountEstimate>;
  isTemplate?: InputMaybe<Scalars["Boolean"]>;
  jobLength?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nudityType?: InputMaybe<NudityInvolvement>;
  packageId: Scalars["ID"];
  packageTalent?: InputMaybe<Array<PackageTalentInput>>;
  packageVerticals?: InputMaybe<Array<CreatePackageVerticalInput>>;
  postcode?: InputMaybe<Scalars["String"]>;
  selfTapeRequired?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  talentRequired?: InputMaybe<Scalars["Int"]>;
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
  usage?: InputMaybe<Scalars["String"]>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationUpdatePortfolioImageCategoryArgs = {
  name: Scalars["String"];
  portfolioImageCategoryId: Scalars["ID"];
};

export type MutationUpdatePortfolioImagesCategorisationArgs = {
  currentCategoryId: Scalars["ID"];
  imageIds: Array<Scalars["ID"]>;
  targetCategoryIds: Array<Scalars["ID"]>;
};

export type MutationUpdateReviewArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  rating: Scalars["Int"];
  reviewId: Scalars["ID"];
};

export type MutationUpdateSavedTalentCollectionArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type MutationUpdateSavedTalentCollectionsArgs = {
  collectionIds: Array<Scalars["ID"]>;
  talentId: Scalars["ID"];
};

export type MutationUpdateUserArgs = {
  bookerProfile?: InputMaybe<UpdateBookerProfileInput>;
  email?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  userId: Scalars["ID"];
};

export type MutationUpsertCastingRequestsArgs = {
  instructions?: InputMaybe<Scalars["String"]>;
  jobId: Scalars["ID"];
  jobTalentIds: Array<Scalars["ID"]>;
  location: Scalars["String"];
  proposedAt: Scalars["ISO8601DateTime"];
  replyDeadlineAt: Scalars["ISO8601DateTime"];
  timeZone: Scalars["String"];
};

export type MutationUpsertTalentProfileCacheArgs = {
  jsonData: Scalars["String"];
};

export type MutationVerifyPackageBookerArgs = {
  bookerId: Scalars["ID"];
  packageId: Scalars["ID"];
  verificationNote: Scalars["String"];
};

export type MutationVoidInvoiceArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationWithdrawAgencyBriefArgs = {
  jobId: Scalars["ID"];
  reason: Scalars["String"];
};

export type MutationWithdrawOpenCallApplicationArgs = {
  applicationId: Scalars["ID"];
};

export type Note = {
  __typename?: "Note";
  body: Scalars["String"];
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  user?: Maybe<User>;
};

export type Notification = {
  __typename?: "Notification";
  category?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  job?: Maybe<Job>;
  path?: Maybe<Scalars["String"]>;
  subtitle: Scalars["String"];
  title: Scalars["String"];
  unread: Scalars["Boolean"];
};

/** Autogenerated return type of NotificationAdded */
export type NotificationAddedPayload = {
  __typename?: "NotificationAddedPayload";
  message?: Maybe<Message>;
  type: Scalars["String"];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: "NotificationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: "NotificationEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Notification;
};

export enum NudityInvolvement {
  BikiniLingerie = "BIKINI_LINGERIE",
  FullFrontal = "FULL_FRONTAL",
  FullFrontAndBack = "FULL_FRONT_AND_BACK",
  FullNudity = "FULL_NUDITY",
  PartialNudity = "PARTIAL_NUDITY",
}

export type NumericAttribute = {
  __typename?: "NumericAttribute";
  conversionType: ConversionType;
  name: Scalars["String"];
  value?: Maybe<Scalars["Int"]>;
};

export type OpenCall = {
  __typename?: "OpenCall";
  acceptingApplications: Scalars["Boolean"];
  applicantCap?: Maybe<Scalars["Int"]>;
  applicationAccess: Scalars["String"];
  /** Banded application volume: 50+, 100+, 250+, 500+, or null below 50. */
  applicationBand?: Maybe<Scalars["String"]>;
  /** Client-reviewable applications. Batched, unlike applications { totalCount }. */
  applicationCount?: Maybe<Scalars["Int"]>;
  applicationDeadline?: Maybe<Scalars["ISO8601DateTime"]>;
  /** Call-level reason applications are open or closed. Discloses no viewer state. */
  applicationStatus: OpenCallApplicationStatus;
  applications: JobApplicationConnection;
  bookingCompanyId?: Maybe<Scalars["ID"]>;
  brand?: Maybe<Scalars["String"]>;
  brief?: Maybe<Scalars["String"]>;
  broadcasts?: Maybe<Array<OpenCallBroadcast>>;
  city?: Maybe<Scalars["String"]>;
  coarseLocation?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  crewSize?: Maybe<HeadcountEstimate>;
  currency: Scalars["String"];
  dateMode: Scalars["String"];
  deckFiles: Array<DeckFile>;
  endDate?: Maybe<Scalars["ISO8601Date"]>;
  expensesCovered: Scalars["Boolean"];
  externallyAccessible: Scalars["Boolean"];
  heroImage?: Maybe<PublicImage>;
  id: Scalars["ID"];
  jobVerticals: Array<PublicJobVertical>;
  kind?: Maybe<JobKind>;
  location?: Maybe<Scalars["String"]>;
  logo?: Maybe<PublicImage>;
  myApplication?: Maybe<JobApplication>;
  pendingPostedByName?: Maybe<Scalars["String"]>;
  postedByName?: Maybe<Scalars["String"]>;
  publicCopyNeedsReview?: Maybe<Scalars["Boolean"]>;
  publicUrl?: Maybe<Scalars["String"]>;
  publicationRequirementsMissing?: Maybe<Array<Scalars["String"]>>;
  publishedBrand?: Maybe<Scalars["String"]>;
  publishedPostedByName?: Maybe<Scalars["String"]>;
  questions: Array<OpenCallQuestion>;
  requirements?: Maybe<Scalars["String"]>;
  slug: Scalars["String"];
  startDate?: Maybe<Scalars["ISO8601Date"]>;
  state: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
  visibility: Scalars["String"];
};

export type OpenCallApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  jobVerticalId?: InputMaybe<Scalars["ID"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export enum OpenCallApplicationStatus {
  /** The call has reached its applicant cap. */
  CapReached = "CAP_REACHED",
  /** Closed by hand, or never published. */
  Closed = "CLOSED",
  /** The application deadline has passed. */
  DeadlinePassed = "DEADLINE_PASSED",
  /** Published, inside its deadline and under its applicant cap. */
  Open = "OPEN",
}

export type OpenCallAudiencePreview = {
  __typename?: "OpenCallAudiencePreview";
  alreadyAppliedCount: Scalars["Int"];
  alreadyInvitedCount: Scalars["Int"];
  blockedReason?: Maybe<Scalars["String"]>;
  dispatchConfigured: Scalars["Boolean"];
  environmentBlockedCount: Scalars["Int"];
  excludedCount: Scalars["Int"];
  fingerprint: Scalars["String"];
  ineligibleCount: Scalars["Int"];
  reachableCount: Scalars["Int"];
  suppressedCount: Scalars["Int"];
  unreachableCount: Scalars["Int"];
};

export type OpenCallBroadcast = {
  __typename?: "OpenCallBroadcast";
  acceptedCount: Scalars["Int"];
  cancelledReason?: Maybe<Scalars["String"]>;
  completedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  createdAt: Scalars["ISO8601DateTime"];
  failedCount: Scalars["Int"];
  id: Scalars["ID"];
  pendingCount: Scalars["Int"];
  recipientLimit: Scalars["Int"];
  skippedCount: Scalars["Int"];
  startedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  state: Scalars["String"];
  unknownCount: Scalars["Int"];
};

export type OpenCallBroadcastResult = {
  __typename?: "OpenCallBroadcastResult";
  broadcast?: Maybe<OpenCallBroadcast>;
  dryRun: Scalars["Boolean"];
  preview: OpenCallAudiencePreview;
  queuedCount: Scalars["Int"];
};

/** The connection type for OpenCall. */
export type OpenCallConnection = {
  __typename?: "OpenCallConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenCallEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OpenCall>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type OpenCallEdge = {
  __typename?: "OpenCallEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node?: Maybe<OpenCall>;
};

export type OpenCallQuestion = {
  __typename?: "OpenCallQuestion";
  id: Scalars["ID"];
  options: Array<Scalars["String"]>;
  position: Scalars["Int"];
  prompt: Scalars["String"];
  questionType: Scalars["String"];
  required: Scalars["Boolean"];
};

export type OpenCallQuestionInput = {
  options?: InputMaybe<Array<Scalars["String"]>>;
  prompt: Scalars["String"];
  questionType: Scalars["String"];
  required?: InputMaybe<Scalars["Boolean"]>;
};

export type OptionTypeWithColour = {
  __typename?: "OptionTypeWithColour";
  colour?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  value: Scalars["String"];
};

export type OrderingOption = {
  __typename?: "OrderingOption";
  direction: Scalars["String"];
  field: Scalars["String"];
  label: Scalars["String"];
};

export type OutboundPayment = {
  __typename?: "OutboundPayment";
  additionalPayments?: Maybe<Array<LineItem>>;
  amount: Scalars["Float"];
  bankedId?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  currency: Scalars["String"];
  id: Scalars["ID"];
  jobTalent?: Maybe<JobTalent>;
  lineItems?: Maybe<Array<LineItem>>;
  paymentBatch?: Maybe<PaymentBatch>;
  remittanceLetterUrl?: Maybe<Scalars["String"]>;
  sentAt?: Maybe<Scalars["ISO8601DateTime"]>;
  state: OutboundPaymentState;
};

export enum OutboundPaymentState {
  Failed = "FAILED",
  Pending = "PENDING",
  Sent = "SENT",
}

export type Package = {
  __typename?: "Package";
  additionalNotes?: Maybe<Scalars["String"]>;
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  agency?: Maybe<Agency>;
  allTravelFeesCovered: Scalars["Boolean"];
  booker?: Maybe<PackageBooker>;
  bookerCompany?: Maybe<Scalars["String"]>;
  bookerEmail?: Maybe<Scalars["String"]>;
  bookerName?: Maybe<Scalars["String"]>;
  bookerPhoneNumber?: Maybe<Scalars["String"]>;
  brand?: Maybe<Scalars["String"]>;
  /** @deprecated Vertical specific fields have been moved to the package vertical relation */
  budget?: Maybe<Scalars["Float"]>;
  canEditCuration: Scalars["Boolean"];
  cateringProvided?: Maybe<Scalars["Boolean"]>;
  city?: Maybe<Scalars["String"]>;
  clientDetailsUnderReview?: Maybe<Scalars["Boolean"]>;
  clonedFrom?: Maybe<Package>;
  country?: Maybe<Scalars["String"]>;
  county?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  creator?: Maybe<User>;
  deckFiles?: Maybe<Array<DeckFile>>;
  /** @deprecated Vertical specific fields have been moved to the package vertical relation */
  deliverables?: Maybe<Array<Scalars["String"]>>;
  description?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["ISO8601Date"]>;
  hasClones?: Maybe<Scalars["Boolean"]>;
  headcountEstimate?: Maybe<HeadcountEstimate>;
  id: Scalars["ID"];
  isTemplate?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Vertical specific fields have been moved to the package vertical relation */
  jobLength?: Maybe<Scalars["String"]>;
  jobSlug?: Maybe<Scalars["String"]>;
  jobState?: Maybe<JobState>;
  kind?: Maybe<JobKind>;
  location?: Maybe<Scalars["String"]>;
  mayConvertToJob: Scalars["Boolean"];
  name: Scalars["String"];
  nudityType?: Maybe<NudityInvolvement>;
  packageTalent: Array<PackageTalent>;
  packageVerticals: Array<PackageVertical>;
  postcode?: Maybe<Scalars["String"]>;
  selfTapeRequired?: Maybe<Scalars["Boolean"]>;
  shortlistCount: Scalars["Int"];
  slug: Scalars["String"];
  spansMultipleDays: Scalars["Boolean"];
  startDate?: Maybe<Scalars["ISO8601Date"]>;
  state: PackageState;
  /** @deprecated Vertical specific fields have been moved to the package vertical relation */
  talentRequired?: Maybe<Scalars["Int"]>;
  travelExpenseCover?: Maybe<Scalars["Float"]>;
  usage?: Maybe<Scalars["String"]>;
  /** @deprecated Vertical specific fields have been moved to the package vertical relation */
  vertical?: Maybe<TalentVertical>;
  virtual: Scalars["Boolean"];
};

export type PackageBooker = {
  __typename?: "PackageBooker";
  email: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
};

/** The connection type for Package. */
export type PackageConnection = {
  __typename?: "PackageConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PackageEdge>>>;
  /** A list of nodes. */
  nodes: Array<Package>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type PackageEdge = {
  __typename?: "PackageEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Package;
};

export enum PackageState {
  ConvertedToJob = "CONVERTED_TO_JOB",
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type PackageTalent = {
  __typename?: "PackageTalent";
  curatorName?: Maybe<Scalars["String"]>;
  curatorRationale?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  proposedRole?: Maybe<Scalars["String"]>;
  state: PackageTalentState;
  talent: User;
};

export type PackageTalentInput = {
  curatorRationale?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  proposedRole?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<PackageTalentState>;
};

export enum PackageTalentState {
  Optioned = "OPTIONED",
  Pending = "PENDING",
}

export type PackageVertical = {
  __typename?: "PackageVertical";
  budget?: Maybe<Scalars["Float"]>;
  deliverables?: Maybe<Array<Scalars["String"]>>;
  id: Scalars["ID"];
  jobLength?: Maybe<Scalars["String"]>;
  talentRequired?: Maybe<Scalars["Int"]>;
  vertical: TalentVertical;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]>;
};

export type PasswordValidation = {
  __typename?: "PasswordValidation";
  errors: Array<Scalars["String"]>;
  valid: Scalars["Boolean"];
};

export type PayloadError = {
  __typename?: "PayloadError";
  code: PayloadErrorCode;
  /** The argument at fault, when there is one. */
  field?: Maybe<Scalars["String"]>;
  /** Written for the person who tried. */
  message: Scalars["String"];
};

export enum PayloadErrorCode {
  /** The caller may not do this. */
  Forbidden = "FORBIDDEN",
  /** The caller has made too many of these requests for now. */
  RateLimited = "RATE_LIMITED",
  /** An input cannot be used as it is. `field` names it, when there is one. */
  Validation = "VALIDATION",
}

export type PaymentBatch = {
  __typename?: "PaymentBatch";
  authorizationUrl?: Maybe<Scalars["String"]>;
  bankedId?: Maybe<Scalars["String"]>;
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  outboundPayments: Array<OutboundPayment>;
  sealedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  sentAt?: Maybe<Scalars["ISO8601DateTime"]>;
  state: PaymentBatchState;
};

export enum PaymentBatchState {
  Pending = "PENDING",
  Processing = "PROCESSING",
  Sealed = "SEALED",
  Sent = "SENT",
}

export type PaymentDetails = {
  __typename?: "PaymentDetails";
  accountNumber: Scalars["String"];
  iban: Scalars["String"];
  sortCode: Scalars["String"];
  swift: Scalars["String"];
};

export type PaymentIntentResponse = {
  __typename?: "PaymentIntentResponse";
  clientSecret: Scalars["String"];
};

export enum PaymentMethod {
  BankTransfer = "BANK_TRANSFER",
  Card = "CARD",
  Invoice = "INVOICE",
  OpenBanking = "OPEN_BANKING",
  TradeAccount = "TRADE_ACCOUNT",
}

export type PortfolioImage = {
  __typename?: "PortfolioImage";
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  height?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  mediaUrl: Scalars["String"];
  sortWeight: Scalars["Int"];
  width?: Maybe<Scalars["Int"]>;
};

export type PortfolioImageCategorisationInput = {
  name: Scalars["String"];
  sortWeight: Scalars["Int"];
};

export type PortfolioImageCategory = {
  __typename?: "PortfolioImageCategory";
  id: Scalars["ID"];
  name: Scalars["String"];
  portfolioImages: Array<PortfolioImage>;
};

export type PortfolioImageInput = {
  categories: Array<PortfolioImageCategorisationInput>;
  fileData: FileUploadInput;
  sortWeight: Scalars["Int"];
};

export type PresignedUrl = {
  __typename?: "PresignedUrl";
  headers: Array<KeyValue>;
  key: Scalars["String"];
  url: Scalars["String"];
};

export type Profile = AgentProfile | BookerProfile | TalentProfile;

export type ProfileAttribute = {
  __typename?: "ProfileAttribute";
  field: Scalars["String"];
  icon: Scalars["String"];
  label: Scalars["String"];
  verticalSpecific?: Maybe<Scalars["Boolean"]>;
};

export enum Pronouns {
  HeHim = "HE_HIM",
  HeThey = "HE_THEY",
  SheHer = "SHE_HER",
  SheThey = "SHE_THEY",
  TheyThem = "THEY_THEM",
  ZeHir = "ZE_HIR",
}

export type PublicImage = {
  __typename?: "PublicImage";
  height?: Maybe<Scalars["Int"]>;
  url: Scalars["String"];
  width?: Maybe<Scalars["Int"]>;
};

export type PublicJobVertical = {
  __typename?: "PublicJobVertical";
  budget: Scalars["Float"];
  id: Scalars["ID"];
  talentRequired: Scalars["Int"];
  vertical: TalentVertical;
};

/** The query root of this schema */
export type Query = {
  __typename?: "Query";
  acceptanceRate?: Maybe<AcceptanceRate>;
  agencies?: Maybe<Array<Agency>>;
  agency?: Maybe<Agency>;
  agencyLifecycle?: Maybe<AgencyLifecyclePreview>;
  agencyRosterTransfer?: Maybe<AgencyRosterTransfer>;
  agentInvitation?: Maybe<AgentInvitation>;
  auth?: Maybe<Auth>;
  authSso?: Maybe<AuthSso>;
  billingCompanies?: Maybe<Array<BillingCompany>>;
  booker?: Maybe<User>;
  bookerCompany?: Maybe<BookingCompany>;
  bookerInvitation?: Maybe<BookerInvitation>;
  bookers?: Maybe<UserConnection>;
  bookingCompanies?: Maybe<BookingCompanyConnection>;
  castingHelpRequests: Array<CastingRequest>;
  castingRequest?: Maybe<CastingRequest>;
  chatHelpRooms: Array<Chatroom>;
  chatroom?: Maybe<Chatroom>;
  dayRateDistribution: Array<Scalars["Int"]>;
  discoverableOpenCalls: OpenCallConnection;
  /** When the send log recorded its first email. Nil while it is empty. */
  emailSendLogStartedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  emailTemplate?: Maybe<EmailPreview>;
  emailTemplates?: Maybe<Array<EmailTemplate>>;
  enabledFeatures: Array<Scalars["String"]>;
  filterOptions: FilterOptions;
  instagramAuthUrl?: Maybe<Scalars["String"]>;
  instagramConnectionStatus?: Maybe<SocialMedia>;
  invoiceReissueCandidates?: Maybe<Array<Invoice>>;
  invoices?: Maybe<InvoiceConnection>;
  /** Find a Job Record */
  job?: Maybe<Job>;
  /** Returns the price breakdown of a specific talent of a job. */
  jobTalentPriceBreakdown: JobTalentPriceBreakdown;
  jobTalentRejectionReasons: Array<KeyValue>;
  maximumMinDayRate: Scalars["Int"];
  me?: Maybe<User>;
  openCall?: Maybe<OpenCall>;
  openCallAgencyApplications: JobApplicationVerticalConnection;
  openCalls: OpenCallConnection;
  package?: Maybe<Package>;
  paymentBatch?: Maybe<PaymentBatch>;
  paymentBatches?: Maybe<Array<PaymentBatch>>;
  sendEmailVerification?: Maybe<SuccessResponse>;
  talent?: Maybe<User>;
  talentApplication?: Maybe<TalentApplication>;
  talentApplications?: Maybe<TalentApplicationConnection>;
  talentInvitation?: Maybe<TalentInvitation>;
  talentOnboarding?: Maybe<TalentOnboarding>;
  termsStatus?: Maybe<TermsStatus>;
  thirdPartyAgencies?: Maybe<AgencyConnection>;
  totalJobCount: Scalars["Int"];
  unreadThreadsCount?: Maybe<UnreadThreadsCount>;
  validateEmail: Validation;
  validatePassword: PasswordValidation;
  verifyEmail?: Maybe<SuccessResponse>;
  verticalConfigurations?: Maybe<Array<VerticalConfiguration>>;
  verticalTalentSearch?: Maybe<UserConnection>;
};

/** The query root of this schema */
export type QueryAcceptanceRateArgs = {
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  fee: Scalars["Float"];
  jobLength?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<JobKind>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  usages?: InputMaybe<Array<UsageInput>>;
  vertical: TalentVertical;
};

/** The query root of this schema */
export type QueryAgencyArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryAgencyLifecycleArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryAgencyRosterTransferArgs = {
  requestKey: Scalars["String"];
};

/** The query root of this schema */
export type QueryAgentInvitationArgs = {
  token: Scalars["String"];
};

/** The query root of this schema */
export type QueryAuthArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

/** The query root of this schema */
export type QueryAuthSsoArgs = {
  idToken: Scalars["String"];
  nonce?: InputMaybe<Scalars["String"]>;
  providerId: Scalars["String"];
};

/** The query root of this schema */
export type QueryBookerArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryBookerCompanyArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryBookerInvitationArgs = {
  token: Scalars["String"];
};

/** The query root of this schema */
export type QueryBookersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  companyId?: InputMaybe<Scalars["ID"]>;
  excludedIds?: InputMaybe<Array<Scalars["ID"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  kind?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  nameOrEmail?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars["String"]>;
};

/** The query root of this schema */
export type QueryBookingCompaniesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  hasMultipleMembers?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars["String"]>;
};

/** The query root of this schema */
export type QueryCastingRequestArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryChatroomArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryDayRateDistributionArgs = {
  verticals?: InputMaybe<Array<TalentVertical>>;
};

/** The query root of this schema */
export type QueryDiscoverableOpenCallsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** The query root of this schema */
export type QueryEmailTemplateArgs = {
  draft?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

/** The query root of this schema */
export type QueryInstagramAuthUrlArgs = {
  talentId?: InputMaybe<Scalars["ID"]>;
};

/** The query root of this schema */
export type QueryInstagramConnectionStatusArgs = {
  talentId?: InputMaybe<Scalars["ID"]>;
};

/** The query root of this schema */
export type QueryInvoiceReissueCandidatesArgs = {
  billingCompanyId: Scalars["ID"];
};

/** The query root of this schema */
export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<InvoiceFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

/** The query root of this schema */
export type QueryJobArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryJobTalentPriceBreakdownArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryMaximumMinDayRateArgs = {
  verticals?: InputMaybe<Array<TalentVertical>>;
};

/** The query root of this schema */
export type QueryOpenCallArgs = {
  slug: Scalars["String"];
};

/** The query root of this schema */
export type QueryOpenCallAgencyApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endorsementState?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

/** The query root of this schema */
export type QueryOpenCallsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  state?: InputMaybe<Scalars["String"]>;
  visibility?: InputMaybe<Scalars["String"]>;
};

/** The query root of this schema */
export type QueryPackageArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryPaymentBatchArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryPaymentBatchesArgs = {
  sortColumn?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
};

/** The query root of this schema */
export type QuerySendEmailVerificationArgs = {
  email: Scalars["String"];
};

/** The query root of this schema */
export type QueryTalentArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryTalentApplicationArgs = {
  id: Scalars["ID"];
};

/** The query root of this schema */
export type QueryTalentApplicationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  nameOrEmail?: InputMaybe<Scalars["String"]>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
};

/** The query root of this schema */
export type QueryTalentInvitationArgs = {
  token: Scalars["String"];
};

/** The query root of this schema */
export type QueryTalentOnboardingArgs = {
  token: Scalars["String"];
};

/** The query root of this schema */
export type QueryThirdPartyAgenciesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<AgencyFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

/** The query root of this schema */
export type QueryValidateEmailArgs = {
  email: Scalars["String"];
};

/** The query root of this schema */
export type QueryValidatePasswordArgs = {
  password: Scalars["String"];
};

/** The query root of this schema */
export type QueryVerifyEmailArgs = {
  token: Scalars["String"];
};

/** The query root of this schema */
export type QueryVerticalTalentSearchArgs = {
  after?: InputMaybe<Scalars["String"]>;
  agencyId?: InputMaybe<Scalars["ID"]>;
  availableFrom?: InputMaybe<Scalars["ISO8601Date"]>;
  availableTo?: InputMaybe<Scalars["ISO8601Date"]>;
  before?: InputMaybe<Scalars["String"]>;
  bookmarked?: InputMaybe<Scalars["Boolean"]>;
  excludeAgencyIds?: InputMaybe<Array<Scalars["ID"]>>;
  excludedIds?: InputMaybe<Array<Scalars["Int"]>>;
  fields?: InputMaybe<Array<VerticalFieldInput>>;
  first?: InputMaybe<Scalars["Int"]>;
  gender?: InputMaybe<Gender>;
  genders?: InputMaybe<Array<Gender>>;
  group?: InputMaybe<TalentSearchGroup>;
  groupId?: InputMaybe<Scalars["Int"]>;
  groupIds?: InputMaybe<Array<Scalars["Int"]>>;
  hobbies?: InputMaybe<Array<Scalars["String"]>>;
  inSameAgency?: InputMaybe<Scalars["Boolean"]>;
  isContactLaunch?: InputMaybe<Scalars["Boolean"]>;
  isContactOpen?: InputMaybe<Scalars["Boolean"]>;
  isContactSelect?: InputMaybe<Scalars["Boolean"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  location?: InputMaybe<Scalars["String"]>;
  locationContext?: InputMaybe<TalentSearchLocationContext>;
  locations?: InputMaybe<Array<Scalars["String"]>>;
  maxAge?: InputMaybe<Scalars["Int"]>;
  minAge?: InputMaybe<Scalars["Int"]>;
  minDayRate?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  random?: InputMaybe<Scalars["Boolean"]>;
  recentlyBooked?: InputMaybe<Scalars["Boolean"]>;
  seed?: InputMaybe<Scalars["Float"]>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars["String"]>;
  vertical?: InputMaybe<TalentVertical>;
  verticals?: InputMaybe<Array<TalentVertical>>;
  workspace?: InputMaybe<JobWorkspace>;
};

export type Review = {
  __typename?: "Review";
  createdAt: Scalars["ISO8601DateTime"];
  hidden?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  job: Job;
  rating: Scalars["Int"];
  reviewable: Profile;
  reviewableName: Scalars["String"];
  reviewer?: Maybe<User>;
};

/** The connection type for Review. */
export type ReviewConnection = {
  __typename?: "ReviewConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewEdge>>>;
  /** A list of nodes. */
  nodes: Array<Review>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type ReviewEdge = {
  __typename?: "ReviewEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: Review;
};

export type SavedBankAccount = {
  __typename?: "SavedBankAccount";
  id: Scalars["ID"];
  kind?: Maybe<BankAccountKind>;
  maskedIdentifier: Scalars["String"];
  ownerName: Scalars["String"];
  updatedAt: Scalars["ISO8601DateTime"];
};

export type SavedTalent = {
  __typename?: "SavedTalent";
  bookerProfile: BookerProfile;
  createdAt: Scalars["ISO8601DateTime"];
  id: Scalars["ID"];
  labels: Array<Scalars["String"]>;
  talent: User;
  timeSinceBookmarked: Scalars["String"];
};

export type SavedTalentCollection = {
  __typename?: "SavedTalentCollection";
  id: Scalars["ID"];
  memberCount: Scalars["Int"];
  memberIds: Array<Scalars["ID"]>;
  members: UserConnection;
  name: Scalars["String"];
  slug: Scalars["String"];
  talentVerticals: Array<TalentVertical>;
};

export type SavedTalentCollectionMembersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  vertical?: InputMaybe<TalentVertical>;
};

/** The connection type for SavedTalentCollection. */
export type SavedTalentCollectionConnection = {
  __typename?: "SavedTalentCollectionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SavedTalentCollectionEdge>>>;
  /** A list of nodes. */
  nodes: Array<SavedTalentCollection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type SavedTalentCollectionEdge = {
  __typename?: "SavedTalentCollectionEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: SavedTalentCollection;
};

/** The connection type for SavedTalent. */
export type SavedTalentConnection = {
  __typename?: "SavedTalentConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SavedTalentEdge>>>;
  /** A list of nodes. */
  nodes: Array<SavedTalent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type SavedTalentEdge = {
  __typename?: "SavedTalentEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: SavedTalent;
};

/** Autogenerated return type of SendEmailTest */
export type SendEmailTestPayload = {
  __typename?: "SendEmailTestPayload";
  errors: Array<PayloadError>;
  /** The staging allowlist sent it to its fallback inbox instead of you. */
  redirected: Scalars["Boolean"];
  /** Where the test actually went. Nil when it was not sent. */
  sentTo?: Maybe<Scalars["String"]>;
};

export type SocialMedia = {
  __typename?: "SocialMedia";
  followerCount: Scalars["Int"];
  handle: Scalars["String"];
  instagramConnected: Scalars["Boolean"];
  lastSyncedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  platform: SocialMediaPlatform;
};

export type SocialMediaInput = {
  followerCount?: InputMaybe<Scalars["Int"]>;
  handle: Scalars["String"];
  platform: SocialMediaPlatform;
};

export enum SocialMediaPlatform {
  Instagram = "INSTAGRAM",
  Tiktok = "TIKTOK",
  Youtube = "YOUTUBE",
}

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export type SortOrderInput = {
  column: Scalars["String"];
  direction: SortDirection;
};

export type Subscription = {
  __typename?: "Subscription";
  notificationAdded: NotificationAddedPayload;
};

export type SuccessResponse = {
  __typename?: "SuccessResponse";
  success: Scalars["Boolean"];
};

export type TalentApplication = {
  __typename?: "TalentApplication";
  aasmState: Scalars["String"];
  assets: Array<Asset>;
  biography?: Maybe<Scalars["String"]>;
  bustSize?: Maybe<Scalars["Int"]>;
  chestSize?: Maybe<Scalars["Int"]>;
  city?: Maybe<Scalars["String"]>;
  complexion?: Maybe<Complexion>;
  createdAt: Scalars["ISO8601DateTime"];
  dateOfBirth?: Maybe<Scalars["ISO8601Date"]>;
  email: Scalars["String"];
  eyeColour?: Maybe<EyeColour>;
  gender?: Maybe<Gender>;
  hairColour?: Maybe<HairColour>;
  hairStyle?: Maybe<HairStyle>;
  height?: Maybe<Scalars["Int"]>;
  hipSize?: Maybe<Scalars["Int"]>;
  hobbies?: Maybe<Array<Scalars["String"]>>;
  id: Scalars["ID"];
  instagramUsername?: Maybe<Scalars["String"]>;
  legLength?: Maybe<Scalars["Int"]>;
  location?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  pronouns?: Maybe<Pronouns>;
  shoeSize?: Maybe<Scalars["Int"]>;
  suitSize?: Maybe<Scalars["Int"]>;
  waistSize?: Maybe<Scalars["Int"]>;
};

/** The connection type for TalentApplication. */
export type TalentApplicationConnection = {
  __typename?: "TalentApplicationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TalentApplicationEdge>>>;
  /** A list of nodes. */
  nodes: Array<TalentApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type TalentApplicationEdge = {
  __typename?: "TalentApplicationEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: TalentApplication;
};

export type TalentInvitation = {
  __typename?: "TalentInvitation";
  createdAt: Scalars["ISO8601DateTime"];
  email: Scalars["String"];
  id: Scalars["ID"];
  published: Scalars["Boolean"];
  vertical: TalentVertical;
};

export type TalentLocation = {
  __typename?: "TalentLocation";
  id: Scalars["ID"];
  latitude?: Maybe<Scalars["Float"]>;
  longitude?: Maybe<Scalars["Float"]>;
  name: Scalars["String"];
};

export type TalentLocationInput = {
  name: Scalars["String"];
};

export type TalentOnboarding = {
  __typename?: "TalentOnboarding";
  email: Scalars["String"];
  name: Scalars["String"];
};

export type TalentPaymentGuide = {
  __typename?: "TalentPaymentGuide";
  clientPayment: Scalars["String"];
  nextStep: Scalars["String"];
  showBankDetailsLink: Scalars["Boolean"];
  talentPayment: Scalars["String"];
};

export type TalentProfile = {
  __typename?: "TalentProfile";
  additionalLocations: Array<TalentLocation>;
  age?: Maybe<Scalars["Int"]>;
  agency: Agency;
  assets: Array<Asset>;
  averageRating?: Maybe<Scalars["Float"]>;
  biography?: Maybe<Scalars["String"]>;
  bookers?: Maybe<Array<User>>;
  cardUrl?: Maybe<Scalars["String"]>;
  contractUrl?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  dateOfBirth?: Maybe<Scalars["ISO8601DateTime"]>;
  dietaryRequirements?: Maybe<Array<Scalars["String"]>>;
  gender?: Maybe<Gender>;
  hobbies?: Maybe<Array<Scalars["String"]>>;
  id: Scalars["ID"];
  instagramUsername?: Maybe<Scalars["String"]>;
  isAgencyFeatured?: Maybe<Scalars["Boolean"]>;
  isContactLaunch?: Maybe<Scalars["Boolean"]>;
  isContactOpen?: Maybe<Scalars["Boolean"]>;
  isContactSelect?: Maybe<Scalars["Boolean"]>;
  isFeatured?: Maybe<Scalars["Boolean"]>;
  jobReview?: Maybe<Review>;
  lastPortfolioUpload?: Maybe<PortfolioImage>;
  lastPortfolioUploads?: Maybe<Array<PortfolioImage>>;
  /** @deprecated Please use primary_location instead */
  location: Scalars["String"];
  mediaCounts?: Maybe<Array<MissingMediaCount>>;
  minDayRate?: Maybe<Scalars["Int"]>;
  missingInformation?: Maybe<Array<Scalars["String"]>>;
  missingMeasurements?: Maybe<Array<Scalars["String"]>>;
  numericAttributes?: Maybe<Array<NumericAttribute>>;
  pastClients?: Maybe<Array<Scalars["String"]>>;
  portfolioImageCategories: Array<PortfolioImageCategory>;
  portfolioImages: Array<PortfolioImage>;
  primaryLocation: TalentLocation;
  pronouns?: Maybe<Pronouns>;
  published?: Maybe<Scalars["Boolean"]>;
  reviewableJobsForBooker?: Maybe<Array<Job>>;
  reviews?: Maybe<Array<Review>>;
  scrubbedBiography?: Maybe<Scalars["String"]>;
  selfManaged?: Maybe<Scalars["Boolean"]>;
  socialMediaFields?: Maybe<Array<SocialMedia>>;
  totalReviews: Scalars["Int"];
  twitterUsername?: Maybe<Scalars["String"]>;
  unhideContactSelectRequest?: Maybe<TalentProfileRequest>;
  vertical: TalentVertical;
  verticalConfiguration?: Maybe<VerticalConfiguration>;
  verticalData?: Maybe<Array<KeyValue>>;
  website?: Maybe<Scalars["String"]>;
  yearsExperience?: Maybe<Scalars["Int"]>;
};

export type TalentProfileJobReviewArgs = {
  jobId: Scalars["ID"];
};

export type TalentProfileLastPortfolioUploadsArgs = {
  count?: InputMaybe<Scalars["Int"]>;
};

export type TalentProfileReviewableJobsForBookerArgs = {
  bookerId: Scalars["ID"];
};

export type TalentProfileReviewsArgs = {
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type TalentProfileCache = {
  __typename?: "TalentProfileCache";
  jsonData: Scalars["String"];
  user: User;
};

export type TalentProfileRequest = {
  __typename?: "TalentProfileRequest";
  declineReason?: Maybe<Scalars["String"]>;
  requestReason?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
};

export type TalentProfileRequestInput = {
  declineReason?: InputMaybe<Scalars["String"]>;
  requestReason?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export enum TalentSearchGroup {
  HiddenProfiles = "HIDDEN_PROFILES",
  IncompleteMeasurements = "INCOMPLETE_MEASUREMENTS",
  IncompleteProfiles = "INCOMPLETE_PROFILES",
  LowMediaCount = "LOW_MEDIA_COUNT",
  PublishedProfiles = "PUBLISHED_PROFILES",
  WithoutSignedContract = "WITHOUT_SIGNED_CONTRACT",
  WithSignedContract = "WITH_SIGNED_CONTRACT",
}

export enum TalentSearchLocationContext {
  AdditionalOnly = "ADDITIONAL_ONLY",
  PrimaryAndAdditional = "PRIMARY_AND_ADDITIONAL",
  PrimaryOnly = "PRIMARY_ONLY",
}

export enum TalentVertical {
  FashionModel = "FASHION_MODEL",
  Hmua = "HMUA",
  Influencer = "INFLUENCER",
  Photographer = "PHOTOGRAPHER",
}

export type TermsStatus = {
  __typename?: "TermsStatus";
  acceptanceRequired: Scalars["Boolean"];
  acceptedAt?: Maybe<Scalars["ISO8601DateTime"]>;
  documentSha256: Scalars["String"];
  effectiveAt: Scalars["ISO8601DateTime"];
  privacyUrl: Scalars["String"];
  termsUrl: Scalars["String"];
  version: Scalars["String"];
};

export type Timeslot = {
  __typename?: "Timeslot";
  from: Scalars["ISO8601DateTime"];
  to: Scalars["ISO8601DateTime"];
};

export type TimeslotInput = {
  from: Scalars["ISO8601DateTime"];
  to: Scalars["ISO8601DateTime"];
};

export type UnreadThreadsCount = {
  __typename?: "UnreadThreadsCount";
  broadcastCount: Scalars["Int"];
  confirmedJobsCount: Scalars["Int"];
  totalCount: Scalars["Int"];
};

export type UpdateBookerProfileInput = {
  autoApprovalDisabled?: InputMaybe<Scalars["Boolean"]>;
  bookingCompany?: InputMaybe<UpdateBookingCompanyInput>;
  company?: InputMaybe<Scalars["String"]>;
  invoiceBillingAddress?: InputMaybe<Scalars["String"]>;
  invoiceBillingName?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type UpdateBookingCompanyInput = {
  waiveInvoiceFee?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateJobDetailsInput = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  addressLine1?: InputMaybe<Scalars["String"]>;
  addressLine2?: InputMaybe<Scalars["String"]>;
  affiliate?: InputMaybe<Scalars["String"]>;
  allTravelFeesCovered?: InputMaybe<Scalars["Boolean"]>;
  brand?: InputMaybe<Scalars["String"]>;
  cateringProvided?: InputMaybe<Scalars["Boolean"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  deckFiles?: InputMaybe<Array<FileUploadInput>>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["ISO8601Date"]>;
  headcountEstimate?: InputMaybe<HeadcountEstimate>;
  kind?: InputMaybe<JobKind>;
  location?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nudityType?: InputMaybe<NudityInvolvement>;
  postcode?: InputMaybe<Scalars["String"]>;
  selfTapeRequired?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["ISO8601Date"]>;
  travelExpenseCover?: InputMaybe<Scalars["Float"]>;
  usage?: InputMaybe<Scalars["String"]>;
  usages?: InputMaybe<Array<UsageInput>>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

export type UpdateJobVerticalInput = {
  budget?: InputMaybe<Scalars["Float"]>;
  deliverables?: InputMaybe<Array<Scalars["String"]>>;
  jobLength?: InputMaybe<Scalars["String"]>;
  talentRequired?: InputMaybe<Scalars["Int"]>;
  timeslots?: InputMaybe<Array<TimeslotInput>>;
  vertical: TalentVertical;
};

export type UpdateOwnBookerProfileInput = {
  company?: InputMaybe<Scalars["String"]>;
  kind?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type UpdateOwnTalentProfileInput = {
  additionalLocations?: InputMaybe<Array<TalentLocationInput>>;
  biography?: InputMaybe<Scalars["String"]>;
  dietaryRequirements?: InputMaybe<Array<Scalars["String"]>>;
  id?: InputMaybe<Scalars["ID"]>;
  instagramUsername?: InputMaybe<Scalars["String"]>;
  isContactLaunch?: InputMaybe<Scalars["Boolean"]>;
  primaryLocation?: InputMaybe<TalentLocationInput>;
  pronouns?: InputMaybe<Pronouns>;
};

export type UpdateSortOrderInput = {
  id: Scalars["ID"];
  weight: Scalars["Int"];
};

export type UpdateTalentProfileInput = {
  additionalLocations?: InputMaybe<Array<TalentLocationInput>>;
  agency?: InputMaybe<Scalars["ID"]>;
  agencyId?: InputMaybe<Scalars["ID"]>;
  assets?: InputMaybe<Array<AssetFileUploadInput>>;
  biography?: InputMaybe<Scalars["String"]>;
  contract?: InputMaybe<FileUploadInput>;
  dateOfBirth?: InputMaybe<Scalars["ISO8601Date"]>;
  dietaryRequirements?: InputMaybe<Array<Scalars["String"]>>;
  gender?: InputMaybe<Gender>;
  hobbies?: InputMaybe<Array<Scalars["String"]>>;
  id?: InputMaybe<Scalars["ID"]>;
  instagramUsername?: InputMaybe<Scalars["String"]>;
  isAgencyFeatured?: InputMaybe<Scalars["Boolean"]>;
  isContactOpen?: InputMaybe<Scalars["Boolean"]>;
  isContactSelect?: InputMaybe<Scalars["Boolean"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]>;
  minDayRate?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  pastClients?: InputMaybe<Array<Scalars["String"]>>;
  primaryLocation?: InputMaybe<TalentLocationInput>;
  pronouns?: InputMaybe<Pronouns>;
  published?: InputMaybe<Scalars["Boolean"]>;
  socialMediaFields?: InputMaybe<Array<SocialMediaInput>>;
  unhideContactSelectRequest?: InputMaybe<TalentProfileRequestInput>;
  verticalData?: InputMaybe<Scalars["JSON"]>;
  website?: InputMaybe<Scalars["String"]>;
  yearsExperience?: InputMaybe<Scalars["Int"]>;
};

/** Autogenerated return type of UpsertTalentProfileCache */
export type UpsertTalentProfileCachePayload = {
  __typename?: "UpsertTalentProfileCachePayload";
  errors: Array<Scalars["String"]>;
  talentProfileCache?: Maybe<TalentProfileCache>;
};

export type Usage = {
  __typename?: "Usage";
  form: Array<Scalars["String"]>;
  length: Scalars["String"];
  location: MediaLocation;
  mediaType: MediaType;
};

export type UsageInput = {
  form: Array<Scalars["String"]>;
  length: Scalars["String"];
  location: MediaLocation;
  mediaType: MediaType;
};

export type User = {
  __typename?: "User";
  activityStream?: Maybe<ActivityLogConnection>;
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  agency?: Maybe<Agency>;
  agencyUsers?: Maybe<Array<User>>;
  agentProfile?: Maybe<AgentProfile>;
  archivedJobs?: Maybe<JobsConnection>;
  assignedLiveJobCount?: Maybe<Scalars["Int"]>;
  availableFeatures?: Maybe<Array<Scalars["String"]>>;
  averageJobPay?: Maybe<Scalars["Int"]>;
  averageResponseTimeMinutes?: Maybe<Scalars["Int"]>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountChangeAvailable: Scalars["Boolean"];
  bookerProfile?: Maybe<BookerProfile>;
  bookmarked?: Maybe<Scalars["Boolean"]>;
  chatrooms?: Maybe<ChatroomConnection>;
  city?: Maybe<Scalars["String"]>;
  completedJobCount?: Maybe<Scalars["Int"]>;
  convertedPackageCount?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  county?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["ISO8601DateTime"]>;
  dashboardUpcomingJobCount?: Maybe<Scalars["Int"]>;
  defaultGroup?: Maybe<Group>;
  email?: Maybe<Scalars["String"]>;
  emailVerified: Scalars["Boolean"];
  featuredAsset?: Maybe<Asset>;
  firstName?: Maybe<Scalars["String"]>;
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"];
  invoices?: Maybe<Array<Invoice>>;
  jobs?: Maybe<JobsConnection>;
  jobsCalendarUrl?: Maybe<Scalars["String"]>;
  kinds?: Maybe<Array<Scalars["String"]>>;
  lastActionAt?: Maybe<Scalars["ISO8601DateTime"]>;
  lastName?: Maybe<Scalars["String"]>;
  liveJobs?: Maybe<JobsConnection>;
  name: Scalars["String"];
  nextJob?: Maybe<Job>;
  nextJobStartDate?: Maybe<Scalars["ISO8601Date"]>;
  notes?: Maybe<Array<Note>>;
  notifications: NotificationConnection;
  packageCount?: Maybe<Scalars["Int"]>;
  payments?: Maybe<Array<OutboundPayment>>;
  pendingJobCount?: Maybe<Scalars["Int"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  postcode?: Maybe<Scalars["String"]>;
  previousBrands?: Maybe<Array<Scalars["String"]>>;
  previousLocationByBrand?: Maybe<Scalars["String"]>;
  previousLocations?: Maybe<Array<Scalars["String"]>>;
  profile?: Maybe<Profile>;
  registeringAs?: Maybe<Scalars["String"]>;
  savedBankAccount?: Maybe<SavedBankAccount>;
  shortlistCount?: Maybe<Scalars["Int"]>;
  slug: Scalars["String"];
  staffUsers: Array<Maybe<User>>;
  successfulJobCount?: Maybe<Scalars["Int"]>;
  talentProfile?: Maybe<TalentProfile>;
  talentProfileCache?: Maybe<TalentProfileCache>;
  talentProfiles?: Maybe<Array<TalentProfile>>;
  totalPay?: Maybe<Scalars["Int"]>;
  trustshareVerified?: Maybe<Scalars["Boolean"]>;
  upcomingJobCount?: Maybe<Scalars["Int"]>;
};

export type UserActivityStreamArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type UserArchivedJobsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type UserChatroomsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<ChatroomFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type UserJobsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<JobFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
  workspace?: InputMaybe<JobWorkspace>;
};

export type UserLiveJobsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<JobFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sortOrder?: InputMaybe<SortOrderInput>;
};

export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
};

export type UserPreviousLocationByBrandArgs = {
  brand: Scalars["String"];
};

export type UserTalentProfileArgs = {
  id?: InputMaybe<Scalars["ID"]>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: "UserConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: "UserEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"];
  /** The item at the end of the edge. */
  node: User;
};

export enum UserKind {
  Agent = "AGENT",
  Booker = "BOOKER",
  Talent = "TALENT",
}

export type UtmDataInput = {
  campaign: Scalars["String"];
  content?: InputMaybe<Scalars["String"]>;
  medium: Scalars["String"];
  source: Scalars["String"];
};

export type Validation = {
  __typename?: "Validation";
  errors: Array<Scalars["String"]>;
  valid: Scalars["Boolean"];
};

export type VerticalConfiguration = {
  __typename?: "VerticalConfiguration";
  advancedFilters: Array<Filter>;
  cardType: VerticalConfigurationCard;
  fields: Array<Field>;
  filters: Array<Filter>;
  id: TalentVertical;
  image: Scalars["String"];
  jobCreationSchema: JobCreationSchema;
  jobVerticalDetailsFields: Array<Component>;
  label: Scalars["String"];
  maxConfirmedTalent?: Maybe<Scalars["Int"]>;
  maxShortlistCount?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  newVertical: Scalars["Boolean"];
  orderingOptions: Array<OrderingOption>;
  profileAttributes: Array<ProfileAttribute>;
  selectionImage: Scalars["String"];
};

export enum VerticalConfigurationCard {
  Multiple = "MULTIPLE",
  Single = "SINGLE",
}

export type VerticalFieldInput = {
  name: Scalars["String"];
  value: Scalars["VerticalFieldValueScalar"];
};
